var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-14",
    cx: 250.03,
    cy: 351.04,
    rx: 243.68,
    ry: 140.69,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-14",
    d: "M57.12,455.25l27.12,15.66a10.91,10.91,0,0,0,9.86,0L292.31,356.47c2.73-1.58,2.73-4.12,0-5.7L265.2,335.11a10.91,10.91,0,0,0-9.86,0L57.12,449.56C54.4,451.13,54.4,453.68,57.12,455.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M41.15,415.88c-11.87,6.85-11.87,18,0,24.81s31.1,6.85,43,0,11.86-18,0-24.81S53,409,41.15,415.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-14",
    cx: 406.4,
    cy: 433.26,
    rx: 64.27,
    ry: 37.11,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "31.65 243.48 33.91 244.82 110.69 200.49 108.44 199.15 31.65 243.48",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.44 199.15 33.91 242.17 33.91 76.23 108.44 33.23 108.44 199.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,24.53,29.65,73.78V252.2L115,203Zm-4.26,176L33.91,244.82V76.24L110.69,31.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.69 200.49 108.44 199.15 108.44 33.23 110.69 31.91 110.69 200.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.91 184.35 33.91 187 110.69 142.67 108.44 141.32 33.91 184.35",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.91 126.5 33.91 129.15 110.69 84.82 108.44 83.48 33.91 126.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.95 24.53 112.66 23.21 27.36 72.46 29.65 73.78 114.95 24.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.36 72.46 29.65 73.78 29.65 252.2 27.36 250.89 27.36 72.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.75 57.27 69.04 55.95 69.04 224.55 66.75 223.24 66.75 57.27",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "73.3 53.5 69.04 55.95 69.04 224.55 73.3 222.08 73.3 53.5",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.95 82.36 114.95 87.28 29.65 136.53 29.65 131.61 114.95 82.36",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.95 140.2 114.95 145.12 29.65 194.37 29.65 189.45 114.95 140.2",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.04 108.87 66.75 107.54 33.91 126.5 33.91 129.15 69.04 108.87",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.04 166.69 66.75 165.37 33.91 184.33 33.91 186.98 69.04 166.69",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.83,430.75c-9.52-9.83-15.11-49.82-5.83-57.61H86.26c9.29,7.79,3.7,47.77-5.82,57.6l-.26.27-.33.32a11,11,0,0,1-.86.78l-.22.18c-.24.18-.47.37-.72.55a14.12,14.12,0,0,1-1.23.79c-7.84,4.58-20.54,4.58-28.37,0h0a13,13,0,0,1-1.24-.8c-.24-.17-.45-.34-.67-.51l-.28-.22c-.3-.25-.57-.5-.83-.75l-.38-.37Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.83,430.75c-9.52-9.83-15.11-49.82-5.83-57.61H86.26c9.29,7.79,3.7,47.77-5.82,57.6l-.26.27-.33.32a11,11,0,0,1-.86.78l-.22.18c-.24.18-.47.37-.72.55a14.12,14.12,0,0,1-1.23.79c-7.84,4.58-20.54,4.58-28.37,0h0a13,13,0,0,1-1.24-.8c-.24-.17-.45-.34-.67-.51l-.28-.22c-.3-.25-.57-.5-.83-.75l-.38-.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,370c10.78,6.3,10.78,16.5,0,22.8s-28.27,6.3-39,0-10.78-16.5,0-22.8S71.38,363.71,82.16,370Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,370c10.78,6.3,10.78,16.5,0,22.8s-28.27,6.3-39,0-10.78-16.5,0-22.8S71.38,363.71,82.16,370Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,373c7.92,4.62,7.92,12.12,0,16.74s-20.76,4.63-28.67,0-7.92-12.12,0-16.74S69.05,368.41,77,373Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,373c7.92,4.62,7.92,12.12,0,16.74s-20.76,4.63-28.67,0-7.92-12.12,0-16.74S69.05,368.41,77,373Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3,381c7.91-4.63,20.75-4.63,28.67,0a13.24,13.24,0,0,1,4.75,4.39,13.17,13.17,0,0,1-4.75,4.4c-7.92,4.63-20.76,4.63-28.67,0a13.17,13.17,0,0,1-4.75-4.4A13.24,13.24,0,0,1,48.3,381Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,335.61c-1.75-3.17-5-5.61-2.8-12.75s3-17.4,5-19.46,5.16,4.23,6.37,11.68S76.34,332.27,67.51,335.61Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25,312.06c-2.54-.76-11.08-6.65-10-19.71S52.92,260,58.51,260.13s4.1,10.61,3.56,24.37S60.75,302.84,52.25,312.06Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64,324.21c-4.9,1.54-8.67.7-11.88-5.84s-4-14.65-2.26-15.77,6.85,6.19,9,9.26C43.73,316.49,45.21,317.65,45.64,324.21Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,353.31c-2.87-.59-4.46-1-5.89-5.35s-4.66-9.7-4.38-11.45,4.07.29,7.29,3.57S57.34,350.9,54.17,353.31Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.28,349.79c-4,0-6.47-.47-9.44-6.32s-4-16.61-1.57-18,4.54,3.44,7.94,9.45S40.74,343.12,38.28,349.79Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.74,359.83c-1.7,1.62-3.79,1.87-6.88-.08s-5.56-5.19-5.12-6.12,4.55.83,6.27,1.57C37.61,356.33,39.34,356,40.74,359.83Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.69,346.22c3.73-1,6.29-1.49,7.75-7.9s-.17-17.08-2.87-17.84-3.56,4.45-5.39,11.09S79.44,340.76,81.69,346.22Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.31,357c2.63,1.21,4.2,1.19,6.41-1.71s3.39-6.81,2.65-7.53-4,2.37-5.32,3.67C84,353.41,82.64,353.72,82.31,357Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.82,352.73c-1.58.89-2.91,2.21-4.46,3.16A31.89,31.89,0,0,1,79.13,358c-1.52.65-3.07,1.24-4.56,2l-1.3.66a58.12,58.12,0,0,0,8.14-11.27,35.77,35.77,0,0,0,3.28-10,84.74,84.74,0,0,0,.81-11c0-.17-.22-.37-.26-.12-.68,4.44-1.47,8.88-2.54,13.24a33.66,33.66,0,0,1-4.09,9.94,73.16,73.16,0,0,1-6.41,8.46c-1.65,2-3.3,4-4.87,6.09a32.88,32.88,0,0,0-3.49,5.26q-.17-3.24-.55-6.48c-.46-3.79-1.17-7.55-2-11.29a24.83,24.83,0,0,1,1.29-6.18,54.1,54.1,0,0,1,2.88-6.41c2.09-4.14,4.13-8.24,5.17-12.79a33.35,33.35,0,0,0,.65-4,37.37,37.37,0,0,0,.33-4.49c0-.11-.13-.06-.14,0-.21,1.17-.31,2.36-.56,3.52s-.6,2.44-.94,3.66a58.57,58.57,0,0,1-2.38,6.9c-1.81,4.31-4.31,8.3-6,12.68a26,26,0,0,0-1.11,3.57c-.52-2.27-1-4.53-1.57-6.8-3.25-14.14-6.33-28.46-6.72-43a122,122,0,0,1,.35-13c.16-1.95.34-3.91.61-5.85s.65-4,1-6c0-.11-.1-.17-.14-.05-.57,1.74-.94,3.54-1.4,5.31a45.9,45.9,0,0,0-1,5.33,85.36,85.36,0,0,0-.83,11.06,135.8,135.8,0,0,0,1.67,22.06c.7,4.63,1.58,9.23,2.54,13.82-.24-.35-.49-.68-.74-1a35.66,35.66,0,0,0-4.07-4.44c-2.71-2.49-5.86-4.39-8.74-6.67a14.63,14.63,0,0,1-4.33-5.23c-.05-.1-.13.05-.11.11,1.15,3.28,3.84,5.93,6.53,8,1.51,1.16,3,2.27,4.49,3.5a36.81,36.81,0,0,1,4.24,4.32c.75.9,1.45,1.84,2.11,2.81.31.45.6.9.88,1.37.17.26.31.5.47.72.32,1.44.63,2.87,1,4.31,1.61,7.15,3.45,14.29,4.56,21.54.39,2.52.65,5.06.82,7.6a24,24,0,0,0-3.09-3.21c-.15-.13-.32-.26-.47-.4-.27-.46-.59-.91-.78-1.32a21.19,21.19,0,0,1-1.12-3c-.63-2.1-1-4.26-1.48-6.41-.84-4.08-2.09-8.35-5.32-11.21,0,0-.1.08-.07.12,2.68,3.32,3.52,7.65,4.31,11.74a48.16,48.16,0,0,0,1.5,6.25,19.2,19.2,0,0,0,.82,2.06c-1.85-1.45-3.76-2.83-5.66-4.2a73.59,73.59,0,0,1-8.29-6.65,33.89,33.89,0,0,1-6.38-8.64c-2.1-4-3.95-8.09-5.69-12.23-.1-.23-.27,0-.22.18a85.46,85.46,0,0,0,3.47,10.5,35.87,35.87,0,0,0,5.63,8.94A58.06,58.06,0,0,0,50,361.12l-1.42-.32c-1.62-.34-3.27-.53-4.9-.79A31.25,31.25,0,0,1,39,359c-1.74-.55-3.35-1.51-5.1-2-.09,0-.12.17-.06.22A23,23,0,0,0,43.31,361c1.52.27,3.06.46,4.57.75a50.37,50.37,0,0,1,4.87,1.42.41.41,0,0,0,.15,0L55.28,365a51.26,51.26,0,0,1,4.51,3.83A14.87,14.87,0,0,1,62,371.49l.24.45c0,.78.07,1.56.08,2.34.08,4.18-.28,8.32-.51,12.49-.05.85,1.27.8,1.39,0A70.12,70.12,0,0,0,64,375.57c0-.49,0-1,0-1.47,0-.17.08-.34.13-.5a13.84,13.84,0,0,1,1.53-3.17,47.66,47.66,0,0,1,3.44-4.8c.61-.77,1.24-1.53,1.88-2.28l.14-.05a47.63,47.63,0,0,1,4.37-2.57c1.4-.66,2.84-1.21,4.25-1.85a22.94,22.94,0,0,0,8.25-6C88,352.87,87.9,352.68,87.82,352.73Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.82,352.73c-1.58.89-2.91,2.21-4.46,3.16A31.89,31.89,0,0,1,79.13,358c-1.52.65-3.07,1.24-4.56,2l-1.3.66a58.12,58.12,0,0,0,8.14-11.27,35.77,35.77,0,0,0,3.28-10,84.74,84.74,0,0,0,.81-11c0-.17-.22-.37-.26-.12-.68,4.44-1.47,8.88-2.54,13.24a33.66,33.66,0,0,1-4.09,9.94,73.16,73.16,0,0,1-6.41,8.46c-1.65,2-3.3,4-4.87,6.09a32.88,32.88,0,0,0-3.49,5.26q-.17-3.24-.55-6.48c-.46-3.79-1.17-7.55-2-11.29a24.83,24.83,0,0,1,1.29-6.18,54.1,54.1,0,0,1,2.88-6.41c2.09-4.14,4.13-8.24,5.17-12.79a33.35,33.35,0,0,0,.65-4,37.37,37.37,0,0,0,.33-4.49c0-.11-.13-.06-.14,0-.21,1.17-.31,2.36-.56,3.52s-.6,2.44-.94,3.66a58.57,58.57,0,0,1-2.38,6.9c-1.81,4.31-4.31,8.3-6,12.68a26,26,0,0,0-1.11,3.57c-.52-2.27-1-4.53-1.57-6.8-3.25-14.14-6.33-28.46-6.72-43a122,122,0,0,1,.35-13c.16-1.95.34-3.91.61-5.85s.65-4,1-6c0-.11-.1-.17-.14-.05-.57,1.74-.94,3.54-1.4,5.31a45.9,45.9,0,0,0-1,5.33,85.36,85.36,0,0,0-.83,11.06,135.8,135.8,0,0,0,1.67,22.06c.7,4.63,1.58,9.23,2.54,13.82-.24-.35-.49-.68-.74-1a35.66,35.66,0,0,0-4.07-4.44c-2.71-2.49-5.86-4.39-8.74-6.67a14.63,14.63,0,0,1-4.33-5.23c-.05-.1-.13.05-.11.11,1.15,3.28,3.84,5.93,6.53,8,1.51,1.16,3,2.27,4.49,3.5a36.81,36.81,0,0,1,4.24,4.32c.75.9,1.45,1.84,2.11,2.81.31.45.6.9.88,1.37.17.26.31.5.47.72.32,1.44.63,2.87,1,4.31,1.61,7.15,3.45,14.29,4.56,21.54.39,2.52.65,5.06.82,7.6a24,24,0,0,0-3.09-3.21c-.15-.13-.32-.26-.47-.4-.27-.46-.59-.91-.78-1.32a21.19,21.19,0,0,1-1.12-3c-.63-2.1-1-4.26-1.48-6.41-.84-4.08-2.09-8.35-5.32-11.21,0,0-.1.08-.07.12,2.68,3.32,3.52,7.65,4.31,11.74a48.16,48.16,0,0,0,1.5,6.25,19.2,19.2,0,0,0,.82,2.06c-1.85-1.45-3.76-2.83-5.66-4.2a73.59,73.59,0,0,1-8.29-6.65,33.89,33.89,0,0,1-6.38-8.64c-2.1-4-3.95-8.09-5.69-12.23-.1-.23-.27,0-.22.18a85.46,85.46,0,0,0,3.47,10.5,35.87,35.87,0,0,0,5.63,8.94A58.06,58.06,0,0,0,50,361.12l-1.42-.32c-1.62-.34-3.27-.53-4.9-.79A31.25,31.25,0,0,1,39,359c-1.74-.55-3.35-1.51-5.1-2-.09,0-.12.17-.06.22A23,23,0,0,0,43.31,361c1.52.27,3.06.46,4.57.75a50.37,50.37,0,0,1,4.87,1.42.41.41,0,0,0,.15,0L55.28,365a51.26,51.26,0,0,1,4.51,3.83A14.87,14.87,0,0,1,62,371.49l.24.45c0,.78.07,1.56.08,2.34.08,4.18-.28,8.32-.51,12.49-.05.85,1.27.8,1.39,0A70.12,70.12,0,0,0,64,375.57c0-.49,0-1,0-1.47,0-.17.08-.34.13-.5a13.84,13.84,0,0,1,1.53-3.17,47.66,47.66,0,0,1,3.44-4.8c.61-.77,1.24-1.53,1.88-2.28l.14-.05a47.63,47.63,0,0,1,4.37-2.57c1.4-.66,2.84-1.21,4.25-1.85a22.94,22.94,0,0,0,8.25-6C88,352.87,87.9,352.68,87.82,352.73Z",
    style: {
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.59,343.79V25c0-7-3.5-9-6.61-10.77s-8.22-2.88-12.63-.33L86.93,118.62c-4.41,2.55-8,8.75-8,13.84V451.29c0,5.1,3.2,8.1,6.3,9.9s8.52,3.76,12.94,1.21L279.59,357.64A15,15,0,0,0,287.59,343.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.4,346.38,95.78,453l0-320-14.54-8.39a16.28,16.28,0,0,0-2.34,7.87V451.29c0,5.1,3.2,8.1,6.3,9.9s8.52,3.76,12.94,1.21L279.59,357.64a15.25,15.25,0,0,0,6.92-7.73l-.45-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.38,22.6l-181.74,105A12.42,12.42,0,0,0,92,137.26V453.87c0,5.47,3.89,7.71,8.63,5L279.38,355.63a14.09,14.09,0,0,0,6.36-11V26.27C285.74,22.23,282.88,20.58,279.38,22.6Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.29,49.16V330.82a13.54,13.54,0,0,1-6.11,10.59L102.59,441.08c-3.37,2-6.11.38-6.11-3.52V154a13.66,13.66,0,0,1,4.29-9.21c.2-.18.38-.36.58-.53a12.4,12.4,0,0,1,1.24-.85L272.94,45.05l.61-.36C277.81,42.23,281.29,44.24,281.29,49.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,334.55A13.54,13.54,0,0,0,272.41,324V45.36L102.59,143.42a12.4,12.4,0,0,0-1.24.85c-.2.17-.38.35-.58.53A13.66,13.66,0,0,0,96.48,154V432.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,96.32l25.92-15c.92-.53,1.66-.15,1.66.84a3.55,3.55,0,0,1-1.66,2.75l-25.92,15c-.92.53-1.66.15-1.66-.84A3.56,3.56,0,0,1,166.61,96.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.41,76c1-.59,1.87-.11,1.87,1.08a4.15,4.15,0,0,1-1.87,3.24c-1,.59-1.87.11-1.87-1.08A4.15,4.15,0,0,1,200.41,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,165.3a6.78,6.78,0,0,0-3-5.35,2,2,0,0,0-2-.16c-.37.22-1.82,1-2.21,1.27a2.3,2.3,0,0,0-.91,2.09v22.3a6.74,6.74,0,0,0,3,5.34,2,2,0,0,0,2,.21c.41-.21,1.9-1.07,2.29-1.3a2.33,2.33,0,0,0,.91-2.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.23,166.56v22.3c0,2-1.33,2.88-3,1.93a6.74,6.74,0,0,1-3-5.34v-22.3c0-2,1.32-2.87,3-1.93A6.77,6.77,0,0,1,87.23,166.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,204.33a6.78,6.78,0,0,0-3-5.35,2,2,0,0,0-2-.16l-2.21,1.26a2.33,2.33,0,0,0-.91,2.1v22.3a6.74,6.74,0,0,0,3,5.34,2,2,0,0,0,2,.21c.41-.21,1.9-1.08,2.29-1.31a2.3,2.3,0,0,0,.91-2.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.23,205.59v22.3c0,2-1.33,2.87-3,1.93a6.74,6.74,0,0,1-3-5.34v-22.3c0-2,1.32-2.87,3-1.93A6.75,6.75,0,0,1,87.23,205.59Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Resume--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.6,41.6,114.91,142.91a7.27,7.27,0,0,0-3.29,5.69v284a7.24,7.24,0,0,0,3.3,5.68l.66.38a7.3,7.3,0,0,0,6.58,0L297.85,337.15a7.25,7.25,0,0,0,3.29-5.69V47.65a7.22,7.22,0,0,0-3.3-5.68l-.66-.38A7.3,7.3,0,0,0,290.6,41.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,331.69c0,2.89-2,4.73-4.54,6.18l-173.18,100c-2.5,1.44-4.54.28-4.54-2.63V154.17h0a9,9,0,0,1,4.52-7.83l173.19-100a3,3,0,0,1,4.55,2.62h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,46.91a2,2,0,0,1,2,2V331.69c0,2.07-1.25,3.71-4,5.31L122.92,437a3.16,3.16,0,0,1-1.53.49c-1.36,0-1.51-1.57-1.51-2.25V154.17a8.06,8.06,0,0,1,4-7l173.19-100a2,2,0,0,1,1-.28m0-1a3,3,0,0,0-1.51.41l-173.19,100a9,9,0,0,0-4.52,7.83V435.22c0,2.06,1,3.25,2.51,3.25a4.14,4.14,0,0,0,2-.62l173.18-100c2.51-1.45,4.54-3.29,4.54-6.18V48.94a3,3,0,0,0-3-3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,149.75a9,9,0,0,0-1.16,4.43v8.9l-7.25-4.19V148.6a6.57,6.57,0,0,1,.93-3.17Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,149.75a9,9,0,0,0-1.16,4.43v8.9l-7.25-4.19V148.6a6.57,6.57,0,0,1,.93-3.17Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.88,163.07,301.14,57.85V48.94a3,3,0,0,0-4.55-2.62l-173.19,100a9,9,0,0,0-4.52,7.83Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,47.65v1.29a3,3,0,0,0-4.55-2.62l-173.19,100a8.65,8.65,0,0,0-3.3,3.3.24.24,0,0,0,0,.1l-7.5-4.33a6.73,6.73,0,0,1,2.37-2.5L290.6,41.6a7.28,7.28,0,0,1,6.57,0l.67.38A7.22,7.22,0,0,1,301.14,47.65Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,47.65v1.29a3,3,0,0,0-4.55-2.62l-173.19,100a8.65,8.65,0,0,0-3.3,3.3.24.24,0,0,0,0,.1l-7.5-4.33a6.73,6.73,0,0,1,2.37-2.5L290.6,41.6a7.28,7.28,0,0,1,6.57,0l.67.38A7.22,7.22,0,0,1,301.14,47.65Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.45,62.72c1.12-.65,2-.13,2,1.17a4.51,4.51,0,0,1-2,3.52c-1.12.64-2,.12-2-1.18A4.47,4.47,0,0,1,276.45,62.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,58c1.12-.65,2-.13,2,1.17a4.51,4.51,0,0,1-2,3.52c-1.12.64-2,.12-2-1.18A4.47,4.47,0,0,1,284.58,58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,53.34c1.12-.65,2-.13,2,1.17a4.51,4.51,0,0,1-2,3.52c-1.12.64-2,.12-2-1.18A4.47,4.47,0,0,1,292.7,53.34Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--resume--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.6,211.93l-3.27,1.89-10.79,6.23-.45-.64-2.17-21.19c4,.25,6.79.73,11.23,6.38C184.37,206.15,186.43,208.85,188.6,211.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.33,213.82l-10.79,6.23-22.33,12.89-9.39,5.43c.4-2.06.76-3.88,1.12-5.46.13-.58.26-1.14.38-1.66.2-.88.41-1.66.57-2.34.48-1.86.82-2.95.88-3.21l0-.07s1.51,1.61,4.11-5.37c2.18-5.79-1.59-11.91-2.24-15.3a67.06,67.06,0,0,1,9.41-5.71c2.67-1.26,11.75-1.48,14.84-1,2.37,1.4,4.35,2.66,9.37,8.89a34.2,34.2,0,0,1,2.42,3.32,7,7,0,0,1,.37.64,15.53,15.53,0,0,1,.82,1.63c.06.14.12.28.17.43a3.13,3.13,0,0,1,.19.51A.83.83,0,0,1,185.33,213.82Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,213.82l-10.79,6.23-22.33,12.89-9.39,5.43c.4-2.06.76-3.88,1.12-5.46.13-.58.26-1.14.38-1.66.2-.88.41-1.66.57-2.34.48-1.86.82-2.95.88-3.21l0-.07s1.51,1.61,4.11-5.37c2.18-5.79-1.59-11.91-2.24-15.3a67.06,67.06,0,0,1,9.41-5.71c2.67-1.26,11.75-1.48,14.84-1,2.37,1.4,4.35,2.66,9.37,8.89a34.2,34.2,0,0,1,2.42,3.32,7,7,0,0,1,.37.64,15.53,15.53,0,0,1,.82,1.63c.06.14.12.28.17.43a3.13,3.13,0,0,1,.19.51A.83.83,0,0,1,185.33,213.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.55,225.89c-.09,2-.22,4.5-.34,7.05l-9.39,5.43L138.34,241c.19-4.69.4-10,.56-14.73.37-11.27,1.92-14.17,3.19-16.16a20,20,0,0,1,5.58-5.1C154.17,209.18,152.92,218.38,152.55,225.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,170.37c.07.52.56.83,1,1.25a4.28,4.28,0,0,1,1,3.55,3.71,3.71,0,0,1-2.07,2.9c-1,.59-2.36,1-2.49,2.34-.09.93.23,1.9.21,2.85a3.74,3.74,0,0,1-2.27,3.37,7.77,7.77,0,0,0-2.89,1.76c-.63.73-.54,1.82-1.13,2.6s-1.47,1.69-2.53,1.58a8.15,8.15,0,0,0-1.34-.21,3.75,3.75,0,0,0-1.86.62c-1.1.75-1.9,1.82-3.34,1.84-1.05,0-1.91-.74-3-.59s-1.69.77-2.66.9a25.46,25.46,0,0,1-3.27.08c-1.23,0-1.22-.56-1.71-1.46s-1-1.61-1.43-2.41a48,48,0,0,0-3.81-5.56c-3.76-4.55-5.17-12.57-.07-16.91,0,0,.21-6.83,5.48-10.17a19,19,0,0,1,3.31-1.66,15.72,15.72,0,0,1,2.78-.78,58.4,58.4,0,0,0,7.29-2.13c2.25-.71,4.77-1.32,7-.09a5.37,5.37,0,0,1,2.22,1.81c.68,1.1.59,2.47,1.18,3.6.71,1.33,1.91,1.44,3.09,2.15a4.84,4.84,0,0,1,2.79,5.3c-.19,1.13-1.15,2-1.43,3A1.39,1.39,0,0,0,182.58,170.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,164.62s3.86,5.12,3.41,17.17c-.28,7.78-1.22,10.8-4.37,12.55a14.51,14.51,0,0,1-6.31,1.21l-.07,5.14-11.73,1.52-.42-12.37a2.78,2.78,0,0,1-4.23-.14c-2.55-2.52-2.62-6.95-.71-8.72,2.8-2.61,4.89-.23,5.6,1.29s2.77,1,2.21-2.68-.31-10.28,2.4-11.69C162.74,166.16,167.39,174.18,173.61,164.62Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.29,186.14l4,.67a2.2,2.2,0,0,1-2.34,2.11A2.37,2.37,0,0,1,165.29,186.14Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.29,174.42l-2.72,1.89a2,2,0,0,1,.56-2.48A1.47,1.47,0,0,1,164.29,174.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,172.89l2.8,1.43a1.83,1.83,0,0,0-.67-2.37A1.59,1.59,0,0,0,172.12,172.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.09 175.6 168.89 183.7 172.84 181.71 168.09 175.6",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.34,195.55a21.56,21.56,0,0,1-8.31-2.44,8.48,8.48,0,0,1-2.6-3.56s.46,3.65,2.26,5.07c2.87,2.26,8.62,3.18,8.62,3.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,176.94a1.27,1.27,0,0,0,1.18,1.35A1.31,1.31,0,0,0,174,176.9a1.25,1.25,0,0,0-1.18-1.35A1.33,1.33,0,0,0,171.6,176.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,178.56a1.25,1.25,0,0,0,1.18,1.35,1.32,1.32,0,0,0,1.19-1.39,1.26,1.26,0,0,0-1.18-1.35A1.31,1.31,0,0,0,163,178.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,187.45a2.42,2.42,0,0,1,.47-.06,2.62,2.62,0,0,1,2.25,1.31,1.76,1.76,0,0,1-1.17.22A2,2,0,0,1,165.42,187.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.33,195.86l0,1.45a9.54,9.54,0,0,0,6.5,1.91c4.14-.2,5.43-1.42,5.43-1.42v-1.41a1.32,1.32,0,0,1,1.3.75c.45.87,2,4.37,2.18,6.11s-2.44,5.11-8,5.16c-7.24.06-9.47-3.75-9.89-4.88s.58-3.78,1-5.52S153.45,195.86,154.33,195.86Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.33,195.86l0,1.45a9.54,9.54,0,0,0,6.5,1.91c4.14-.2,5.43-1.42,5.43-1.42v-1.41a1.32,1.32,0,0,1,1.3.75c.45.87,2,4.37,2.18,6.11s-2.44,5.11-8,5.16c-7.24.06-9.47-3.75-9.89-4.88s.58-3.78,1-5.52S153.45,195.86,154.33,195.86Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,178.69a17.37,17.37,0,0,1-.77-1.69c-.17-.72-.05-1.51-.28-2.21a6.85,6.85,0,0,0-.86-1.45,3.47,3.47,0,0,1-.28-2.4,3.15,3.15,0,0,0,0-1.26c-.19-.65-.64-.63-1.07-.42a3.64,3.64,0,0,0-1.46,1.61,28.45,28.45,0,0,0-1.22,3.58c-.63,1.82-1.64,4.76-3,5.93-.28.23-.92.62-.83-.12a19,19,0,0,0,.3-2.92,4,4,0,0,0-.93-2.67,1,1,0,0,0-.68-.35c-.35,0-.42.28-.49.6a8.67,8.67,0,0,1-.3,1c-.22.67-.45,1.34-.66,2-1.26,3.94-2.33,8.16-1.75,12.44a18.54,18.54,0,0,1,.24,2.68c-.11,2-1.42,13.24-1.88,17.28l10.6-6.13c0-1.66-.13-3.33-.18-5a23,23,0,0,1,.11-4,9.56,9.56,0,0,1,1.46-3.52,35.83,35.83,0,0,0,2.9-6.2,20,20,0,0,0,1-4.52A6.25,6.25,0,0,0,207.24,178.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,182.58c.77,1.76,1.51,5.63.66,8a6.52,6.52,0,0,0,1-4.22A6.8,6.8,0,0,0,197.82,182.58Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.16,157.92V333.85l-148.3,85.62V243.54l148.3-85.62m1-1.73L134.86,243V421.2l150.3-86.77V156.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.46 376.98 285.15 334.43 285.15 156.19 211.46 198.74 211.46 376.98",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.46 376.98 285.15 334.43 285.15 156.19 211.46 198.74 211.46 376.98",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,135.26a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3V147.7a.92.92,0,0,1-.1.42.6.6,0,0,1-.23.28l-1,.57a.17.17,0,0,1-.23,0,.41.41,0,0,1-.1-.3v-5l-3.68,2.12v5a.88.88,0,0,1-.1.41.55.55,0,0,1-.23.28l-1,.58a.21.21,0,0,1-.24,0,.43.43,0,0,1-.09-.31V139.61a1.06,1.06,0,0,1,.09-.42.68.68,0,0,1,.24-.28l1-.57a.17.17,0,0,1,.23,0,.38.38,0,0,1,.1.3v4.82l3.68-2.13v-4.82a1,1,0,0,1,.1-.41.7.7,0,0,1,.23-.29Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.26,142.48a10.68,10.68,0,0,1,.21-2.1,10,10,0,0,1,.6-2,7.32,7.32,0,0,1,.94-1.62,4.16,4.16,0,0,1,1.24-1.11,2.07,2.07,0,0,1,1.24-.33,1.43,1.43,0,0,1,.94.49A2.93,2.93,0,0,1,211,137a6.33,6.33,0,0,1,.21,1.7v.85a.88.88,0,0,1-.1.41.55.55,0,0,1-.23.28l-4.07,2.36a1.92,1.92,0,0,0,.11.69.83.83,0,0,0,.31.37.71.71,0,0,0,.46.08,1.43,1.43,0,0,0,.52-.19,2.5,2.5,0,0,0,.63-.49,2.57,2.57,0,0,0,.41-.54,2.64,2.64,0,0,1,.22-.33.63.63,0,0,1,.23-.19l1-.57a.19.19,0,0,1,.24,0,.34.34,0,0,1,.09.3,3.19,3.19,0,0,1-.19.79,6.11,6.11,0,0,1-.53,1.11,7,7,0,0,1-.87,1.18,4.92,4.92,0,0,1-1.2,1,2.12,2.12,0,0,1-1.24.35,1.36,1.36,0,0,1-.94-.5,3.09,3.09,0,0,1-.6-1.26A7.69,7.69,0,0,1,205.26,142.48Zm3-4.54a2.14,2.14,0,0,0-.6.51,3,3,0,0,0-.42.65,3.72,3.72,0,0,0-.38,1.38l2.75-1.59a2.54,2.54,0,0,0-.09-.54,1,1,0,0,0-.22-.44.56.56,0,0,0-.4-.18A1.22,1.22,0,0,0,208.25,137.94Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16,141.71a.92.92,0,0,1-.1.42.6.6,0,0,1-.23.28l-.92.54a.19.19,0,0,1-.24,0,.41.41,0,0,1-.09-.3V130.32a1,1,0,0,1,.09-.41.72.72,0,0,1,.24-.29l.92-.53a.18.18,0,0,1,.23,0,.41.41,0,0,1,.1.31Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.43,139.83a1,1,0,0,1-.1.41.63.63,0,0,1-.23.29l-.93.53a.17.17,0,0,1-.23,0,.41.41,0,0,1-.1-.3V128.43a1.07,1.07,0,0,1,.1-.41.55.55,0,0,1,.23-.28l.93-.54a.18.18,0,0,1,.23,0,.41.41,0,0,1,.1.3Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,127.81a2.35,2.35,0,0,1,1.21-.38,1.38,1.38,0,0,1,.94.34,2.27,2.27,0,0,1,.64.94,4.75,4.75,0,0,1,.27,1.46c0,.11,0,.25,0,.42v1c0,.17,0,.31,0,.43a9.05,9.05,0,0,1-.28,1.77,8.34,8.34,0,0,1-.63,1.67,6.93,6.93,0,0,1-.94,1.41,4.66,4.66,0,0,1-1.21,1,2.35,2.35,0,0,1-1.21.38,1.42,1.42,0,0,1-.94-.33,2.19,2.19,0,0,1-.63-.94,5,5,0,0,1-.28-1.45c0-.11,0-.25,0-.41v-1.05c0-.17,0-.32,0-.44a7.77,7.77,0,0,1,.28-1.77,8.67,8.67,0,0,1,.63-1.68,6.73,6.73,0,0,1,.94-1.42A4.66,4.66,0,0,1,221.9,127.81Zm1.47,3.37a2.56,2.56,0,0,0-.17-.87.85.85,0,0,0-.35-.41.69.69,0,0,0-.45-.05,1.91,1.91,0,0,0-.5.21,2.8,2.8,0,0,0-.5.37,2.7,2.7,0,0,0-.45.57,3.35,3.35,0,0,0-.35.81,4.7,4.7,0,0,0-.17,1.07c0,.11,0,.23,0,.39s0,.31,0,.47,0,.32,0,.48a2.87,2.87,0,0,0,0,.35,2.5,2.5,0,0,0,.17.86.77.77,0,0,0,.35.41.63.63,0,0,0,.45,0,1.87,1.87,0,0,0,.5-.2,2.8,2.8,0,0,0,.5-.37,2.7,2.7,0,0,0,.45-.57,3.35,3.35,0,0,0,.35-.81,4.7,4.7,0,0,0,.17-1.07,3.63,3.63,0,0,0,0-.38v-.94A3.41,3.41,0,0,0,223.37,131.18Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.3,133.09a2.26,2.26,0,0,1,.15-.58.89.89,0,0,1,.37-.45l1.06-.61a.14.14,0,0,1,.19,0,.29.29,0,0,1,.08.24.61.61,0,0,1,0,.14l-.8,3.58a3.2,3.2,0,0,1-.17.49.81.81,0,0,1-.36.41l-.55.32a.15.15,0,0,1-.19,0,.34.34,0,0,1-.07-.25v0Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82,131.45a.17.17,0,0,1-.23,0,.38.38,0,0,1-.1-.3V119a.88.88,0,0,1,.1-.41.58.58,0,0,1,.23-.29l1-.57a.18.18,0,0,1,.23,0,.41.41,0,0,1,.1.3v12.12a1,1,0,0,1-.1.41.64.64,0,0,1-.23.29Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,119.68a1.25,1.25,0,0,1-.11.47.59.59,0,0,1-.23.26l-.46.27a.18.18,0,0,1-.23,0,.51.51,0,0,1-.11-.32l-.27-3.19a1.09,1.09,0,0,1,.06-.51.57.57,0,0,1,.27-.35l1-.6c.13-.07.23-.06.28,0a.84.84,0,0,1,.05.45Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,118.29a5.37,5.37,0,0,1,.71-1.25,3.14,3.14,0,0,1,.86-.79,1.61,1.61,0,0,1,1.26-.28,1.36,1.36,0,0,1,.77.71,5.1,5.1,0,0,1,.39-.9,6.65,6.65,0,0,1,.49-.79,4.92,4.92,0,0,1,.54-.63,3.13,3.13,0,0,1,.55-.41,1.75,1.75,0,0,1,1.16-.32,1.14,1.14,0,0,1,.75.53,3,3,0,0,1,.4,1.16,10.09,10.09,0,0,1,.12,1.62v5a1.07,1.07,0,0,1-.1.42.67.67,0,0,1-.23.28l-.93.54a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3v-5a2.59,2.59,0,0,0-.31-1.6c-.22-.21-.51-.21-.89,0a2.21,2.21,0,0,0-.84,1,4.63,4.63,0,0,0-.37,1.92v5.05a.86.86,0,0,1-.1.41.58.58,0,0,1-.23.29l-.93.53a.17.17,0,0,1-.23,0,.45.45,0,0,1-.1-.3v-5a2.59,2.59,0,0,0-.31-1.6c-.21-.21-.51-.21-.89,0a2.25,2.25,0,0,0-.86,1,4.65,4.65,0,0,0-.35,2v4.95a.86.86,0,0,1-.1.41.58.58,0,0,1-.23.29l-.92.53a.18.18,0,0,1-.24,0,.41.41,0,0,1-.09-.3v-8.74a1,1,0,0,1,.09-.41.72.72,0,0,1,.24-.29l.92-.53a.17.17,0,0,1,.23,0,.38.38,0,0,1,.1.3Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.09,112.69a1.09,1.09,0,0,1,.12-.43.67.67,0,0,1,.23-.26l1-.57a.18.18,0,0,1,.23,0c.07,0,.1.15.1.31a9.63,9.63,0,0,1-.25,1.68,8.59,8.59,0,0,1-.65,1.77,8.84,8.84,0,0,1-1.11,1.65,6.09,6.09,0,0,1-1.63,1.33,3,3,0,0,1-1.48.48,1.62,1.62,0,0,1-1.1-.44,2.83,2.83,0,0,1-.7-1.24,7.43,7.43,0,0,1-.3-1.91c0-.46,0-1,0-1.56s0-1.11,0-1.59a12.17,12.17,0,0,1,.3-2.26,10,10,0,0,1,.7-2,7.94,7.94,0,0,1,1.1-1.71,5.65,5.65,0,0,1,1.48-1.24,3.27,3.27,0,0,1,1.63-.54,1.73,1.73,0,0,1,1.11.37,2.31,2.31,0,0,1,.65,1,5.7,5.7,0,0,1,.25,1.39.92.92,0,0,1-.1.42.66.66,0,0,1-.23.28l-1,.57a.24.24,0,0,1-.23,0,.38.38,0,0,1-.14-.29,1.83,1.83,0,0,0-.17-.64,1.06,1.06,0,0,0-.36-.42.93.93,0,0,0-.59-.12,1.87,1.87,0,0,0-.83.3,2.88,2.88,0,0,0-.82.7,4.41,4.41,0,0,0-.6.94,5.35,5.35,0,0,0-.36,1.11,6.16,6.16,0,0,0-.15,1.2q0,.72,0,1.59c0,.57,0,1.1,0,1.56a3.92,3.92,0,0,0,.15,1,1.62,1.62,0,0,0,.36.68.87.87,0,0,0,.6.26,1.56,1.56,0,0,0,.82-.25,3.91,3.91,0,0,0,1.42-1.46,4.26,4.26,0,0,0,.38-.85A4.47,4.47,0,0,0,258.09,112.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,107.78a5.78,5.78,0,0,1,.23-1,6.21,6.21,0,0,1,1.29-2.24,4.44,4.44,0,0,1,1.09-.88,2.82,2.82,0,0,1,1.12-.4,1.21,1.21,0,0,1,.86.25,1.76,1.76,0,0,1,.56.91,5.37,5.37,0,0,1,.19,1.58v5.52a.88.88,0,0,1-.1.41.63.63,0,0,1-.23.29l-.92.53a.18.18,0,0,1-.24,0,.41.41,0,0,1-.09-.3v-.62a5.49,5.49,0,0,1-.74,1.36,3.93,3.93,0,0,1-1.23,1.09,2.23,2.23,0,0,1-.93.33,1,1,0,0,1-.7-.21,1.45,1.45,0,0,1-.43-.68,3.46,3.46,0,0,1-.15-1.09,4.79,4.79,0,0,1,.59-2.37,6.74,6.74,0,0,1,1.6-1.91l2-1.68q0-.77-.33-.9a1,1,0,0,0-.82.16,1.76,1.76,0,0,0-.48.4,4,4,0,0,0-.32.55,2.32,2.32,0,0,1-.2.32.66.66,0,0,1-.21.17l-1.13.66a.18.18,0,0,1-.21,0A.33.33,0,0,1,261.07,107.78Zm2,4.12a3,3,0,0,0,.74-.61,3.94,3.94,0,0,0,.54-.79,4.76,4.76,0,0,0,.33-.86,3.66,3.66,0,0,0,.11-.84v-.18l-1.66,1.4a3.38,3.38,0,0,0-.72.8,1.59,1.59,0,0,0-.22.81c0,.27.09.41.26.44A1.08,1.08,0,0,0,263.11,111.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,101.9a2.49,2.49,0,0,0-1.05,1.11,4.22,4.22,0,0,0-.32,1.81v4.88a1,1,0,0,1-.1.41.61.61,0,0,1-.23.28l-.93.54a.17.17,0,0,1-.23,0,.41.41,0,0,1-.1-.3v-8.74a1,1,0,0,1,.1-.41.58.58,0,0,1,.23-.29l.93-.53a.18.18,0,0,1,.23,0,.45.45,0,0,1,.1.3v.44a5.83,5.83,0,0,1,.67-1.09,3.42,3.42,0,0,1,.95-.79l.55-.32a.18.18,0,0,1,.23,0,.41.41,0,0,1,.09.3v1.24a1,1,0,0,1-.09.41.7.7,0,0,1-.23.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.82,96.68A2.35,2.35,0,0,1,277,96.3a1.36,1.36,0,0,1,.94.34,2.27,2.27,0,0,1,.64.94,4.75,4.75,0,0,1,.27,1.46c0,.11,0,.25,0,.42v1.05c0,.17,0,.31,0,.42a9,9,0,0,1-.28,1.78,8.58,8.58,0,0,1-.63,1.67,6.54,6.54,0,0,1-.94,1.41,4.66,4.66,0,0,1-1.21,1,2.44,2.44,0,0,1-1.21.38,1.42,1.42,0,0,1-.94-.33,2.29,2.29,0,0,1-.63-.94,5,5,0,0,1-.28-1.45c0-.11,0-.25,0-.41v-1c0-.17,0-.32,0-.44a8.36,8.36,0,0,1,.28-1.77,8.67,8.67,0,0,1,.63-1.68,6.73,6.73,0,0,1,.94-1.42A4.3,4.3,0,0,1,275.82,96.68Zm1.48,3.37a2.79,2.79,0,0,0-.18-.87.86.86,0,0,0-.35-.41.69.69,0,0,0-.45,0,1.91,1.91,0,0,0-.5.21,2.8,2.8,0,0,0-.5.37,2.7,2.7,0,0,0-.45.57,3.8,3.8,0,0,0-.35.81,4.7,4.7,0,0,0-.17,1.07c0,.11,0,.23,0,.39s0,.31,0,.47,0,.32,0,.47a2.93,2.93,0,0,0,0,.36,2.5,2.5,0,0,0,.17.86.81.81,0,0,0,.35.41.63.63,0,0,0,.45.05,1.87,1.87,0,0,0,.5-.2,2.45,2.45,0,0,0,.5-.38,2.9,2.9,0,0,0,.45-.56,3.68,3.68,0,0,0,.35-.82,5.07,5.07,0,0,0,.18-1.06c0-.1,0-.22,0-.38v-.94C277.31,100.27,277.3,100.14,277.3,100.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,102.63a1.07,1.07,0,0,1-.1.41.61.61,0,0,1-.23.28l-.93.54a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3V91.23a.86.86,0,0,1,.1-.41.63.63,0,0,1,.23-.29l.93-.53a.18.18,0,0,1,.23,0,.46.46,0,0,1,.1.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.88,98.73a.17.17,0,0,1,.23,0,.41.41,0,0,1,.1.3v1.65a1,1,0,0,1-.1.41.61.61,0,0,1-.23.28l-1.05.61a.17.17,0,0,1-.23,0,.38.38,0,0,1-.1-.3V100a.88.88,0,0,1,.1-.41.63.63,0,0,1,.23-.29Zm.26-1.79a1,1,0,0,1-.09.41.72.72,0,0,1-.23.29l-.93.53a.18.18,0,0,1-.23,0,.39.39,0,0,1-.1-.3V89.52a.91.91,0,0,1,.1-.41.6.6,0,0,1,.23-.28l.93-.54a.18.18,0,0,1,.23,0,.41.41,0,0,1,.09.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,156.35a1,1,0,0,1-.5-1.86l69.06-39.87a1,1,0,0,1,1,1.73L216,156.22A1,1,0,0,1,215.52,156.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,165.73a1,1,0,0,1-.86-.5,1,1,0,0,1,.36-1.36L284.08,124a1,1,0,0,1,1,1.73L216,165.6A1,1,0,0,1,215.52,165.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,166.67c0,4.11-2.5,8.89-5.59,10.67s-5.58-.11-5.58-4.22,2.5-8.9,5.58-10.68S246,162.55,246,166.67Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.45 175.05 238.72 174.32 238.72 168.85 237.45 169.59 237.45 175.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,168.51a1.8,1.8,0,0,0,.75-1.44c0-.56-.33-.82-.75-.58a1.83,1.83,0,0,0-.75,1.44C237.33,168.49,237.67,168.75,238.08,168.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,170.28a1.83,1.83,0,0,1,.77-1.67c.47-.27.69,0,.69.83v2.86l1.27-.72v-3.47c0-1.46-.63-1.81-1.49-1.31a3.3,3.3,0,0,0-1.24,1.62v-.74l-1.22.71v5.46l1.22-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.28,155.53c0,4.11-2.5,8.89-5.58,10.67s-5.59-.11-5.59-4.22,2.5-8.89,5.59-10.68S265.28,151.41,265.28,155.53Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,155.08c.89-.52,1-.58,1.36-.76a1.53,1.53,0,0,1,.62-.21.54.54,0,0,1,.39.12.74.74,0,0,1,.25.37,2.5,2.5,0,0,1,.11.76c0,.47,0,.61,0,1.8s0,1.34,0,1.82a4.19,4.19,0,0,1-.11.9,2.9,2.9,0,0,1-.25.66,2.32,2.32,0,0,1-.39.56,3.14,3.14,0,0,1-.62.52c-.36.22-.47.29-1.36.81s-1,.57-1.36.76a1.38,1.38,0,0,1-.63.2.52.52,0,0,1-.38-.11.72.72,0,0,1-.25-.37,2.45,2.45,0,0,1-.12-.76c0-.47,0-.61,0-1.81s0-1.34,0-1.82a4.21,4.21,0,0,1,.12-.9,2.79,2.79,0,0,1,.25-.66,3.24,3.24,0,0,1,.38-.56,3,3,0,0,1,.63-.51c.35-.23.46-.29,1.36-.81m0-.81c-.92.53-1,.6-1.39.83a3.82,3.82,0,0,0-1.41,1.54,4.44,4.44,0,0,0-.39,1,5.22,5.22,0,0,0-.15,1.17c0,.49,0,.65,0,1.86s0,1.37,0,1.84a3.23,3.23,0,0,0,.15,1,1.17,1.17,0,0,0,.39.57.81.81,0,0,0,.59.17,2,2,0,0,0,.82-.26c.36-.19.47-.25,1.39-.77s1-.6,1.38-.83a3.94,3.94,0,0,0,.82-.68,3.6,3.6,0,0,0,.59-.86,4.17,4.17,0,0,0,.39-1,5.17,5.17,0,0,0,.16-1.18c0-.49,0-.64,0-1.86s0-1.37,0-1.83a3.18,3.18,0,0,0-.16-1,1.07,1.07,0,0,0-.39-.57.85.85,0,0,0-.59-.18,2.13,2.13,0,0,0-.82.27c-.36.18-.47.24-1.38.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,156.45a4.12,4.12,0,0,0-1.73,3.3c0,1.27.77,1.86,1.73,1.31a4.14,4.14,0,0,0,1.72-3.3c0-1.27-.77-1.86-1.72-1.31m0,3.8c-.62.36-1.12,0-1.12-.85a2.69,2.69,0,0,1,1.12-2.14c.62-.36,1.12,0,1.12.85a2.69,2.69,0,0,1-1.12,2.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.9,155.09a1,1,0,0,1-.41.77c-.22.13-.4,0-.4-.3a1,1,0,0,1,.4-.77c.22-.13.41,0,.41.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,144.39c0,4.11-2.5,8.89-5.59,10.67s-5.59-.11-5.59-4.22,2.5-8.89,5.59-10.67S284.58,140.27,284.58,144.39Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.08,150.86a2.69,2.69,0,0,0,.48-.57,3.05,3.05,0,0,0,.3-.63,2.85,2.85,0,0,0,.2-1,1.33,1.33,0,0,0-.17-.74.5.5,0,0,0-.5-.22,2.22,2.22,0,0,0,.33-.52,2.31,2.31,0,0,0,.2-.95,1.21,1.21,0,0,0-.2-.76q-.33-.4-1.11,0l-2.08,1.2v5.72l1.94-1.12A3.67,3.67,0,0,0,278.08,150.86Zm-1.69-3.68.93-.54a1.61,1.61,0,0,1,.51-.21c.16,0,.23.13.23.4a1,1,0,0,1-.17.6,1.52,1.52,0,0,1-.46.41l-1,.6Zm0,3.73v-1.52l1.06-.61a.76.76,0,0,1,.43-.15q.27,0,.27.45a1.35,1.35,0,0,1-.28.88,1.61,1.61,0,0,1-.44.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,149.57a1.16,1.16,0,0,0,1.12-.12,3.12,3.12,0,0,0,1.2-1.31,2.71,2.71,0,0,0,.3-.94l-.84.49a1.49,1.49,0,0,1-.18.38,1.22,1.22,0,0,1-.46.47.62.62,0,0,1-.45.1c-.21,0-.32-.28-.34-.7l2.32-1.34c0-.36,0-.64,0-.82a1.57,1.57,0,0,0-.25-.73.67.67,0,0,0-.55-.31,1.53,1.53,0,0,0-.75.23,3,3,0,0,0-1.13,1.25,4,4,0,0,0-.44,1.94Q279.3,149.33,279.78,149.57Zm.6-3.16a1.23,1.23,0,0,1,.49-.52.46.46,0,0,1,.49-.06c.14.08.21.26.22.54l-1.43.83A2.15,2.15,0,0,1,280.38,146.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.75 143.42 279.88 144.49 279.88 145.07 281.75 143.99 281.75 143.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.7,177.81c0,4.11-2.5,8.89-5.59,10.67s-5.59-.11-5.59-4.22,2.5-8.9,5.59-10.68S226.7,173.69,226.7,177.81Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,186.51l1.49-.86v-5l1-.6.11-1.74-1.15.67v-.95c0-.4.06-.59.34-.75l.81-.47V175.1l-1,.6a3,3,0,0,0-1.61,2.83v1.33l-.78.45V182l.78-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,223.37l32.56-18.8c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-32.56,18.8c-1.08.62-2,.18-2-1A4.23,4.23,0,0,1,241.93,223.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,223.37,263.43,211c1.09-.63,2-.18,2,1a4.22,4.22,0,0,1-2,3.27l-21.5,12.41c-1.08.62-2,.18-2-1A4.23,4.23,0,0,1,241.93,223.37Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,214l32.56-18.79c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-32.56,18.8c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,214Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,214l13-7.49c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-13,7.5c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,214Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,232.75,274.49,214c1.08-.63,2-.19,2,1a4.2,4.2,0,0,1-2,3.26L241.93,237c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,232.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,232.75l28.87-16.67c1.09-.62,2-.18,2,1a4.22,4.22,0,0,1-2,3.26L241.93,237c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,232.75Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,242.13l32.56-18.79c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-32.56,18.8c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,242.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,242.13l21.5-12.41c1.09-.62,2-.18,2,1a4.22,4.22,0,0,1-2,3.26l-21.5,12.41c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,241.93,242.13Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,251.52l32.56-18.8c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27l-32.56,18.79c-1.08.63-2,.18-2-1A4.2,4.2,0,0,1,241.93,251.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,251.52l28.87-16.67c1.09-.63,2-.18,2,1a4.18,4.18,0,0,1-2,3.26l-28.87,16.67c-1.08.63-2,.18-2-1A4.2,4.2,0,0,1,241.93,251.52Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,227.13a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l10.16-5.85a.5.5,0,1,1,.5.86l-10.16,5.86A.47.47,0,0,1,223.65,227.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,236.53a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68l10.16-5.86a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-10.16,5.85A.47.47,0,0,1,223.65,236.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,245.93a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l10.16-5.86a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-10.16,5.86A.57.57,0,0,1,223.65,245.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,255.34a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l10.16-5.85a.5.5,0,0,1,.5.86l-10.16,5.86A.59.59,0,0,1,223.65,255.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,264.74a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68L233.56,258a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-10.16,5.85A.47.47,0,0,1,223.65,264.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.46,
    cy: 216.01,
    rx: 10.88,
    ry: 6.16,
    transform: "translate(-70.1 326.01) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,226.56a3.86,3.86,0,0,1-2-.51c-1.64-.94-2.58-3.11-2.58-6,0-5.29,3.24-11.46,7.22-13.76a4.8,4.8,0,0,1,4.89-.37c1.63.95,2.57,3.11,2.57,5.95,0,5.29-3.24,11.46-7.21,13.76A6,6,0,0,1,208.65,226.56Zm5.63-20.6a5.48,5.48,0,0,0-2.69.82c-3.84,2.21-7,8.19-7,13.32,0,2.65.85,4.67,2.33,5.52a4.36,4.36,0,0,0,4.39-.37c3.84-2.22,7-8.2,7-13.33,0-2.65-.85-4.66-2.32-5.52A3.42,3.42,0,0,0,214.28,206Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.28,219.2l-.05,0s-.08,0-.08-.11c0-.89-.34-1.13-1-.77-.07,0-.12,0-.12-.1,0-.47-.08-.76-.25-.89s-.42-.08-.76.11h0a.07.07,0,0,1-.09,0,.11.11,0,0,1,0-.1c0-.46-.08-.76-.24-.88s-.42-.09-.76.11h0q-.09,0-.12,0a.31.31,0,0,1,0-.21l4.46-8.51c0-.09.13-.14.18-.11l3.44,2.6s0,.15,0,.24l-4.46,8.52A.22.22,0,0,1,212.28,219.2Zm-1-1.28c.64-.29,1-.06,1.12.67l4.17-8-3.25-2.46-4.16,8a.65.65,0,0,1,.66,0,1.17,1.17,0,0,1,.32.91c.36-.18.63-.2.83-.05A1.18,1.18,0,0,1,211.26,217.92Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,223.65a.09.09,0,0,1-.1,0s0-.08,0-.15l1.29-7a.28.28,0,0,1,.16-.22c.07,0,.11.06.09.16l-1.23,6.72,4.51-4.24c.07-.07.14,0,.16,0a.32.32,0,0,1-.09.26l-4.73,4.45Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.56 223.48 208.84 222.08 208.05 221.48 207.56 223.48",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,217a.09.09,0,0,1-.1,0c-.05,0-.05-.15,0-.25l3.75-7.15c.05-.1.13-.14.18-.11s0,.15,0,.25l-3.74,7.15A.35.35,0,0,1,211.85,217Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,216.11a.07.07,0,0,1-.09,0c-.05,0-.05-.15,0-.24l3.74-7.16c.05-.09.14-.14.19-.1s.05.15,0,.24L210.79,216A.18.18,0,0,1,210.7,216.11Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.46,
    cy: 287.92,
    rx: 10.88,
    ry: 6.16,
    transform: "translate(-136.27 369.76) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,298.47a3.86,3.86,0,0,1-2-.51c-1.64-.94-2.58-3.11-2.58-5.95,0-5.29,3.24-11.46,7.22-13.76a4.8,4.8,0,0,1,4.89-.37c1.63.95,2.57,3.11,2.57,5.95,0,5.29-3.24,11.46-7.21,13.76A5.93,5.93,0,0,1,208.65,298.47Zm5.63-20.6a5.48,5.48,0,0,0-2.69.82c-3.84,2.21-7,8.19-7,13.32,0,2.66.85,4.67,2.33,5.52a4.36,4.36,0,0,0,4.39-.37c3.84-2.22,7-8.2,7-13.33,0-2.65-.85-4.66-2.32-5.52A3.42,3.42,0,0,0,214.28,277.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,292.88a.07.07,0,0,1-.09,0,.12.12,0,0,1,0-.1,2.48,2.48,0,0,0-.8-2,2.77,2.77,0,0,1-.77-2.42,6.67,6.67,0,0,1,2.38-4.61h0a1.87,1.87,0,0,1,2.1-.32,2.45,2.45,0,0,1,.9,2.16,6.52,6.52,0,0,1-.8,3,6.56,6.56,0,0,0-.78,2.93.33.33,0,0,1-.13.25Zm.13-.25Zm.58-8.59a6,6,0,0,0-2.15,4.16,2.52,2.52,0,0,0,.69,2.19,2.65,2.65,0,0,1,.88,2.07l1.71-1a7.41,7.41,0,0,1,.86-3,6,6,0,0,0,.72-2.72,2.2,2.2,0,0,0-.81-1.95,1.68,1.68,0,0,0-1.9.29Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.46,294.44l-2,1.14c-.07,0-.13,0-.13-.1v-1.57a.33.33,0,0,1,.13-.25l2-1.13c.07,0,.13,0,.13.09v1.57A.31.31,0,0,1,212.46,294.44Zm-1.84.71,1.71-1V293l-1.71,1Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.77,292.13c-.07.05-.13,0-.13-.09a13.49,13.49,0,0,1,.46-3.57l-1.26.73a8,8,0,0,1,.47,3,.31.31,0,0,1-.13.25c-.08,0-.13,0-.13-.1a6.57,6.57,0,0,0-.53-3.08.27.27,0,0,1,0-.18.36.36,0,0,1,.12-.15l1.67-1a.08.08,0,0,1,.12,0,.27.27,0,0,1,0,.18,11.85,11.85,0,0,0-.53,3.69A.28.28,0,0,1,211.77,292.13Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.48,282.41c-.08,0-.13,0-.13-.1v-1.55a.31.31,0,0,1,.13-.25c.07,0,.13,0,.13.1v1.55A.34.34,0,0,1,211.48,282.41Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.67,284.09s-.09,0-.11,0l-.58-1a.26.26,0,0,1,0-.26c.06-.09.15-.1.18,0l.58,1a.26.26,0,0,1-.05.27Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34,286.61a.07.07,0,0,1-.06,0l-1-.19c-.06,0-.08-.1-.05-.21s.12-.18.18-.16l1,.19c.06,0,.08.1,0,.21A.25.25,0,0,1,208.34,286.61Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85,289.3l-1.16.67c-.07,0-.13,0-.13-.1a.31.31,0,0,1,.13-.25l1.16-.67c.07,0,.13,0,.13.1A.31.31,0,0,1,207.85,289.3Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,292.79a.07.07,0,0,1-.11,0,.29.29,0,0,1,0-.26l1-1.35c.06-.09.14-.1.18,0a.29.29,0,0,1-.05.26l-1,1.35Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,288.05h-.07l-1-.19c-.06,0-.08-.11-.05-.21s.12-.18.18-.17l1,.19c.07,0,.09.11,0,.21A.33.33,0,0,1,215.59,288.05Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,284.49l-1.15.67c-.08,0-.13,0-.13-.1a.28.28,0,0,1,.13-.24l1.15-.67c.08,0,.13,0,.13.1A.28.28,0,0,1,216.23,284.49Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,283s-.09,0-.11,0a.27.27,0,0,1,0-.27l1-1.35c.06-.08.14-.1.17,0a.26.26,0,0,1,0,.26l-1,1.36Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28,282a.07.07,0,0,1-.06,0c-.07,0-.09-.1-.05-.21l.58-1.67c0-.1.11-.18.17-.16s.09.1.05.2l-.58,1.68A.25.25,0,0,1,213.28,282Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,325.68c0-5.22,3.17-11.28,7.08-13.54s7.09.14,7.09,5.35-3.17,11.29-7.09,13.55S204.38,330.9,204.38,325.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,332.14a3.86,3.86,0,0,1-2-.51c-1.64-.95-2.58-3.12-2.58-5.95,0-5.29,3.24-11.46,7.22-13.76a4.8,4.8,0,0,1,4.89-.37c1.63.94,2.57,3.11,2.57,5.94,0,5.3-3.24,11.47-7.21,13.76A6,6,0,0,1,208.65,332.14Zm5.63-20.6a5.46,5.46,0,0,0-2.69.81c-3.84,2.22-7,8.2-7,13.33,0,2.65.85,4.66,2.33,5.51a4.31,4.31,0,0,0,4.39-.37c3.84-2.22,7-8.19,7-13.33,0-2.65-.85-4.66-2.32-5.51A3.42,3.42,0,0,0,214.28,311.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,327.37l-1.84,1.06c-.07,0-.13,0-.13-.1v-1.25a2.16,2.16,0,0,1-.8,0l-.66,1.27c0,.1-.13.14-.18.11l-1.3-1c-.06,0-.06-.15,0-.24l.66-1.27a3.74,3.74,0,0,1-.33-.87l-.94.54c-.07,0-.13,0-.13-.1v-2.46a.31.31,0,0,1,.13-.24l.94-.55a10.05,10.05,0,0,1,.33-1.25l-.66-.5c-.06,0-.06-.15,0-.25l1.3-2.48c0-.1.13-.15.18-.11l.66.5a9,9,0,0,1,.8-.9v-1.25a.31.31,0,0,1,.13-.25l1.84-1.06c.07,0,.13,0,.13.1v1.25a2.17,2.17,0,0,1,.8,0l.66-1.27c.05-.1.14-.14.19-.11l1.3,1a.13.13,0,0,1,0,.1.37.37,0,0,1,0,.14l-.66,1.27a3.74,3.74,0,0,1,.33.87l.94-.54c.07,0,.13,0,.13.1v2.45a.31.31,0,0,1-.13.25l-.94.55a10.05,10.05,0,0,1-.33,1.25l.66.5a.13.13,0,0,1,0,.1.42.42,0,0,1,0,.15l-1.3,2.48c0,.1-.14.15-.19.11l-.66-.5a7,7,0,0,1-.8.9v1.25A.31.31,0,0,1,212.38,327.37Zm-1.71.64,1.58-.91v-1.21a.34.34,0,0,1,.1-.23,7.15,7.15,0,0,0,.92-1c0-.07.11-.1.15-.07l.65.49,1.11-2.14-.64-.48a.19.19,0,0,1,0-.2,8.77,8.77,0,0,0,.38-1.44.35.35,0,0,1,.13-.21l.91-.52V318l-.91.53a.08.08,0,0,1-.13-.06,3.2,3.2,0,0,0-.38-1,.25.25,0,0,1,0-.22l.64-1.23-1.11-.85-.65,1.23c0,.08-.1.13-.15.12a2.21,2.21,0,0,0-.92,0c-.06,0-.1,0-.1-.11v-1.21l-1.58.91v1.21a.34.34,0,0,1-.1.23,7.76,7.76,0,0,0-.91,1c0,.07-.12.1-.16.07l-.64-.49-1.12,2.14.64.48c.05,0,.05.12,0,.2a8.77,8.77,0,0,0-.38,1.44.26.26,0,0,1-.12.2l-.91.53v2.11l.91-.53c.06,0,.11,0,.12.06a3.2,3.2,0,0,0,.38,1,.22.22,0,0,1,0,.22l-.64,1.23,1.12.85.64-1.23c0-.08.11-.13.16-.12a2.16,2.16,0,0,0,.91,0c.06,0,.1,0,.1.11Zm.79-3.43c-1.23.71-2.24-.05-2.24-1.69a5.4,5.4,0,0,1,2.24-4.29c1.24-.71,2.25,0,2.25,1.7A5.37,5.37,0,0,1,211.46,324.58Zm0-5.63a4.76,4.76,0,0,0-2,3.78c0,1.46.89,2.13,2,1.5a4.74,4.74,0,0,0,2-3.78C213.45,319,212.56,318.32,211.46,319Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.46,
    cy: 355.25,
    rx: 10.88,
    ry: 6.16,
    transform: "translate(-198.22 410.73) rotate(-66.95)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.65,365.8a3.86,3.86,0,0,1-2-.51c-1.64-.94-2.58-3.11-2.58-6,0-5.29,3.24-11.46,7.22-13.76a4.8,4.8,0,0,1,4.89-.37c1.63,1,2.57,3.11,2.57,6,0,5.29-3.24,11.46-7.21,13.76A5.93,5.93,0,0,1,208.65,365.8Zm5.63-20.6a5.48,5.48,0,0,0-2.69.82c-3.84,2.21-7,8.19-7,13.32,0,2.66.85,4.67,2.33,5.52a4.34,4.34,0,0,0,4.39-.37c3.84-2.22,7-8.2,7-13.33,0-2.65-.85-4.66-2.32-5.52A3.42,3.42,0,0,0,214.28,345.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,363.33s-.07,0-.09,0a.16.16,0,0,1,0-.16l.72-3.22a4.87,4.87,0,0,1-.57-2.48c0-3.06,1.87-6.64,4.17-8s4.17.08,4.17,3.15-1.87,6.64-4.17,8a3.13,3.13,0,0,1-2,.47l-2.18,2.2Zm4.19-13.48c-2.16,1.25-3.91,4.6-3.91,7.47a4.54,4.54,0,0,0,.56,2.37.21.21,0,0,1,0,.14l-.65,2.94,2-2a.12.12,0,0,1,.1,0,2.94,2.94,0,0,0,1.89-.44c2.15-1.25,3.91-4.6,3.91-7.47S213.69,348.61,211.54,349.85Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.82,354.47a1.35,1.35,0,0,1,.57-1.09c.32-.19.57,0,.57.43a1.35,1.35,0,0,1-.57,1.09C213.07,355.09,212.82,354.89,212.82,354.47Z",
    style: {
      fill: "#0165E1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.89,355.58a1.38,1.38,0,0,1,.57-1.09c.32-.18.58,0,.58.43a1.39,1.39,0,0,1-.58,1.1C211.15,356.2,210.89,356,210.89,355.58Z",
    style: {
      fill: "#0165E1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,356.7a1.36,1.36,0,0,1,.58-1.1c.31-.18.57,0,.57.43a1.38,1.38,0,0,1-.57,1.1C209.22,357.31,209,357.12,209,356.7Z",
    style: {
      fill: "#0165E1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,200.46,255.06,183c.6-.35,1.08-.1,1.08.55a2.3,2.3,0,0,1-1.08,1.79L224.73,202.8c-.6.35-1.08.11-1.08-.54A2.32,2.32,0,0,1,224.73,200.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,211a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l52.8-30.48a.5.5,0,1,1,.5.86L223.9,210.9A.59.59,0,0,1,223.65,211Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,215.66a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L264,191.27a.5.5,0,0,1,.68.18.51.51,0,0,1-.18.69L223.9,215.59A.59.59,0,0,1,223.65,215.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,275.51,255.06,258c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-30.33,17.51c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,224.73,275.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,286a.48.48,0,0,1-.43-.25.5.5,0,0,1,.18-.68l52.8-30.49a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68L223.9,286A.57.57,0,0,1,223.65,286Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,290.7a.5.5,0,0,1-.25-.93l52.8-30.48a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-52.8,30.49A.57.57,0,0,1,223.65,290.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,295.39a.5.5,0,0,1-.25-.93L276.2,264a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-52.8,30.48A.47.47,0,0,1,223.65,295.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,300.07a.5.5,0,0,1-.25-.93L264,275.7a.5.5,0,1,1,.5.86L223.9,300A.57.57,0,0,1,223.65,300.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,308.35l30.33-17.51c.6-.35,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L224.73,310.7c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,224.73,308.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,318.86a.5.5,0,0,1-.25-.93l52.8-30.49a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-52.8,30.49A.47.47,0,0,1,223.65,318.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,323.55a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l52.8-30.48a.5.5,0,1,1,.5.87l-52.8,30.48A.47.47,0,0,1,223.65,323.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,328.23a.5.5,0,0,1-.25-.93l52.8-30.48a.51.51,0,0,1,.69.18.5.5,0,0,1-.19.68l-52.8,30.49A.57.57,0,0,1,223.65,328.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,332.92a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L264,308.54a.5.5,0,0,1,.5.87L223.9,332.85A.47.47,0,0,1,223.65,332.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,341.19l30.33-17.52c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-30.33,17.51c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,224.73,341.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,351.69a.5.5,0,0,1-.25-.93l52.8-30.49a.5.5,0,1,1,.5.87l-52.8,30.48A.47.47,0,0,1,223.65,351.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,356.38a.5.5,0,0,1-.25-.93L276.2,325a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-52.8,30.48A.47.47,0,0,1,223.65,356.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,361.07a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l28.43-16.41a.5.5,0,0,1,.5.86L223.9,361A.59.59,0,0,1,223.65,361.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,247.38l30.33-17.52c.6-.34,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-30.33,17.51c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,147.55,247.38Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,263.81a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,263.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,280.81a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,280.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,374.71a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,374.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,348.19a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,348.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,365.19a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,365.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,390.6a.12.12,0,0,1-.12-.12V383.3a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.12.12,0,0,1,154.59,390.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,301.66a.12.12,0,0,1-.12-.12v-7.18a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v7.18A.13.13,0,0,1,154.59,301.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,320.41a.12.12,0,0,1-.12-.13v-7.17a.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.13v7.17A.13.13,0,0,1,154.59,320.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,330a.12.12,0,0,1-.12-.13v-7.17a.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.13v7.17A.13.13,0,0,1,154.59,330Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,292.14a.12.12,0,0,1-.12-.12v-9a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v9A.12.12,0,0,1,154.59,292.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,271.29a.12.12,0,0,1-.12-.12V266a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v5.14A.12.12,0,0,1,154.59,271.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,310.89a.12.12,0,0,1-.12-.13v-6.88a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v6.88A.13.13,0,0,1,154.59,310.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,338.67a.12.12,0,0,1-.12-.12v-6.37a.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.13v6.37A.12.12,0,0,1,154.59,338.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,355.67a.12.12,0,0,1-.12-.12v-5.14a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v5.14A.12.12,0,0,1,154.59,355.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,381.08a.12.12,0,0,1-.12-.12v-4a.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12v4A.12.12,0,0,1,154.59,381.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,256.78a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,256.78Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,254.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,273.78a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,273.78Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,271.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,341.16a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.39,2.39,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.39,2.39,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,341.16Zm.91-2.63a.82.82,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.58.58,0,0,0-.24-.54A.36.36,0,0,0,155.05,338.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,358.16a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.39,2.39,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.39,2.39,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,358.16Zm.91-2.63a.82.82,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.58.58,0,0,0-.24-.54A.36.36,0,0,0,155.05,355.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,383.57a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,383.57Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.58.58,0,0,0,.24.54.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,380.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,294.63a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.39,2.39,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.39,2.39,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,294.63Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.58.58,0,0,0,.24.54.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,292Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,313.37a.62.62,0,0,1-.33-.08.85.85,0,0,1-.36-.77,2.37,2.37,0,0,1,1.08-1.86.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.09,1.09,0,0,1,154.14,313.37Zm.91-2.62a.79.79,0,0,0-.39.12,2.12,2.12,0,0,0-1,1.65.6.6,0,0,0,.24.55.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.6.6,0,0,0-.24-.55A.46.46,0,0,0,155.05,310.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,266.3a.63.63,0,0,1-.33-.09.83.83,0,0,1-.36-.76,2.39,2.39,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.39,2.39,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,266.3Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.58.58,0,0,0,.24.54.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,263.67Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,283.3a.63.63,0,0,1-.33-.09.83.83,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,283.3Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.58.58,0,0,0,.24.54.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,280.67Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,377.2a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.77,2.37,2.37,0,0,1-1.08,1.86A1,1,0,0,1,154.14,377.2Zm.91-2.63a.82.82,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.59.59,0,0,0,.59-.07,2.12,2.12,0,0,0,1-1.65.59.59,0,0,0-.24-.55A.36.36,0,0,0,155.05,374.57Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,350.68a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,350.68Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,348.05Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,367.68a.63.63,0,0,1-.33-.09.82.82,0,0,1-.36-.76,2.37,2.37,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,367.68Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.62.62,0,0,0,.24.55.6.6,0,0,0,.59-.08,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,365.05Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,393.09a.63.63,0,0,1-.33-.09.83.83,0,0,1-.36-.76,2.39,2.39,0,0,1,1.08-1.87.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.39,2.39,0,0,1-1.08,1.87A1.11,1.11,0,0,1,154.14,393.09Zm.91-2.63a.72.72,0,0,0-.39.13,2.09,2.09,0,0,0-1,1.65.58.58,0,0,0,.24.54.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,390.46Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,304.14a.62.62,0,0,1-.33-.08.84.84,0,0,1-.36-.77,2.37,2.37,0,0,1,1.08-1.86.81.81,0,0,1,.84-.07.83.83,0,0,1,.37.76,2.37,2.37,0,0,1-1.08,1.87A1.09,1.09,0,0,1,154.14,304.14Zm.91-2.62a.79.79,0,0,0-.39.12,2.12,2.12,0,0,0-1,1.65.59.59,0,0,0,.24.55.57.57,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.62.62,0,0,0-.24-.55A.46.46,0,0,0,155.05,301.52Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,322.89a.73.73,0,0,1-.33-.08.85.85,0,0,1-.36-.77,2.39,2.39,0,0,1,1.08-1.86.84.84,0,0,1,.84-.08.86.86,0,0,1,.37.77,2.41,2.41,0,0,1-1.08,1.87A1.09,1.09,0,0,1,154.14,322.89Zm.91-2.62a.79.79,0,0,0-.39.12,2.09,2.09,0,0,0-1,1.65.6.6,0,0,0,.24.55.59.59,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.6.6,0,0,0-.24-.55A.46.46,0,0,0,155.05,320.27Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,332.44a.62.62,0,0,1-.33-.08.85.85,0,0,1-.36-.77,2.37,2.37,0,0,1,1.08-1.87.75.75,0,0,1,1.21.7,2.37,2.37,0,0,1-1.08,1.87A1.09,1.09,0,0,1,154.14,332.44Zm.91-2.62a.79.79,0,0,0-.39.12,2.12,2.12,0,0,0-1,1.65.6.6,0,0,0,.24.55.59.59,0,0,0,.59-.07,2.09,2.09,0,0,0,1-1.65.6.6,0,0,0-.24-.55A.46.46,0,0,0,155.05,329.82Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,259.66a2,2,0,0,1,0-.22,1.29,1.29,0,0,1,.21-.48.7.7,0,0,1,.19-.16.28.28,0,0,1,.19-.06.16.16,0,0,1,.13.06.3.3,0,0,1,.07.15.78.78,0,0,1,0,.22,1.12,1.12,0,0,1,0,.36,2.69,2.69,0,0,1-.16.39l-.45,1,.65-.37s0,0,0,0v0a.11.11,0,0,1,0,.1l-.8.46s0,0,0,0v-.05a.13.13,0,0,1,0-.06.32.32,0,0,1,0-.09l.51-1.07a1.54,1.54,0,0,0,.09-.19l.06-.16a.59.59,0,0,0,0-.13.57.57,0,0,0,0-.13c0-.14,0-.23-.07-.27s-.12-.05-.22,0a.58.58,0,0,0-.21.25,1,1,0,0,0-.09.36.08.08,0,0,1,0,.06l0,0,0,0S146.55,259.7,146.55,259.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.65,259.23c0-.11,0-.22,0-.33a2.81,2.81,0,0,1,.08-.31,1.35,1.35,0,0,1,.15-.26.71.71,0,0,1,.22-.2.34.34,0,0,1,.22-.06.23.23,0,0,1,.14.1.63.63,0,0,1,.08.22,2.66,2.66,0,0,1,0,.3,4.34,4.34,0,0,1,0,.51c0,.11,0,.22,0,.33a1.57,1.57,0,0,1-.08.31,1.3,1.3,0,0,1-.14.26.79.79,0,0,1-.22.19.26.26,0,0,1-.22.06.24.24,0,0,1-.15-.09.63.63,0,0,1-.07-.22,1.39,1.39,0,0,1,0-.3Zm.81-.45a.76.76,0,0,0-.09-.43c-.05-.09-.14-.1-.25,0a.58.58,0,0,0-.26.33,1.49,1.49,0,0,0-.09.54v.47a.83.83,0,0,0,.09.44c0,.08.14.09.26,0a.55.55,0,0,0,.25-.32,1.45,1.45,0,0,0,.09-.54v-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,259.49a.11.11,0,0,1,0,.1l0,0s0,0,0,0v-1.79l-.35.61s0,.05-.06,0l0,0a.07.07,0,0,1,0-.05s0,0,0,0l.41-.73,0,0,0,0,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,258.28a1,1,0,0,0,0-.19.24.24,0,0,0-.08-.11.11.11,0,0,0-.11,0,.24.24,0,0,0-.13,0,.4.4,0,0,0-.12.1.76.76,0,0,0-.08.11l-.06.09a.1.1,0,0,1-.05.06l0,0h0s0,0,0,0l.06-1a.13.13,0,0,1,0-.09l.64-.37s0,0,0,0v.05a.1.1,0,0,1,0,.09l-.56.33,0,.7.08-.11a.49.49,0,0,1,.17-.14.32.32,0,0,1,.18-.06.19.19,0,0,1,.15,0,.44.44,0,0,1,.1.15,1,1,0,0,1,0,.27,1.66,1.66,0,0,1,0,.33,2.31,2.31,0,0,1-.1.28,1.07,1.07,0,0,1-.15.22l-.18.15a.41.41,0,0,1-.19.06.22.22,0,0,1-.14-.05.25.25,0,0,1-.09-.13.48.48,0,0,1,0-.18.09.09,0,0,1,0-.05l0,0,0,0h0a.06.06,0,0,1,0,.05.38.38,0,0,0,0,.14.18.18,0,0,0,.08.07h.09L150,259a.33.33,0,0,0,.13-.11.64.64,0,0,0,.11-.16,1,1,0,0,0,.08-.21A1.66,1.66,0,0,0,150.38,258.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,276.26a2.15,2.15,0,0,1,0-.23,2.25,2.25,0,0,1,.08-.24,1,1,0,0,1,.13-.23,1,1,0,0,1,.19-.17.45.45,0,0,1,.19-.06.26.26,0,0,1,.13.06.34.34,0,0,1,.07.16.71.71,0,0,1,0,.21,1,1,0,0,1-.05.36,2,2,0,0,1-.16.39l-.45,1,.65-.38s0,0,0,.05v0c0,.05,0,.08,0,.09l-.8.47s0,0,0-.05v0a.2.2,0,0,1,0-.07.31.31,0,0,1,0-.09l.5-1.06a1.59,1.59,0,0,0,.09-.2l.06-.15a.69.69,0,0,0,0-.13.61.61,0,0,0,0-.14.38.38,0,0,0-.07-.27s-.12,0-.22,0a.55.55,0,0,0-.21.24,1.06,1.06,0,0,0-.09.37.14.14,0,0,1,0,.06l0,0,0,0S146.53,276.3,146.53,276.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.63,275.83c0-.11,0-.22,0-.33a2.81,2.81,0,0,1,.08-.31,1.1,1.1,0,0,1,.15-.26.61.61,0,0,1,.22-.2.35.35,0,0,1,.22-.06.23.23,0,0,1,.14.1.63.63,0,0,1,.08.22q0,.13,0,.3v.5l0,.34a1.47,1.47,0,0,1-.08.3,1.15,1.15,0,0,1-.14.27.67.67,0,0,1-.22.19.36.36,0,0,1-.22.06.22.22,0,0,1-.15-.1.57.57,0,0,1-.07-.22,1.39,1.39,0,0,1,0-.3Zm.81-.45a.83.83,0,0,0-.09-.44c0-.08-.14-.09-.25,0a.63.63,0,0,0-.26.33,1.44,1.44,0,0,0-.09.53v.48a.76.76,0,0,0,.09.43c.06.09.14.1.26,0a.59.59,0,0,0,.25-.32,1.45,1.45,0,0,0,.09-.54v-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.31,276.09c0,.05,0,.08,0,.09l0,0s0,0,0,0v-1.78l-.35.61s0,.05-.06,0l0,0s0,0,0,0a.08.08,0,0,1,0-.05l.41-.73,0,0h0l0,0s0,0,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,275.33a1.09,1.09,0,0,1,0-.18l0-.16a1.13,1.13,0,0,0,0-.15.76.76,0,0,0,0-.11l.39-1.06,0-.05s0,0,0,0l0,0h0s0,0,0,0v0h0l-.29.81.06-.05.07,0a.38.38,0,0,1,.21-.06.26.26,0,0,1,.15.07.38.38,0,0,1,.09.18.88.88,0,0,1,0,.24,1.33,1.33,0,0,1,0,.28,1.31,1.31,0,0,1-.09.28,1,1,0,0,1-.15.24.6.6,0,0,1-.21.18.29.29,0,0,1-.2.06.26.26,0,0,1-.15-.07.38.38,0,0,1-.09-.18A.88.88,0,0,1,149.58,275.33Zm.82-.48a.66.66,0,0,0,0-.21.24.24,0,0,0-.07-.12.24.24,0,0,0-.12,0,.24.24,0,0,0-.13,0,.63.63,0,0,0-.13.11.91.91,0,0,0-.11.16,1.8,1.8,0,0,0-.08.21,1,1,0,0,0,0,.25.66.66,0,0,0,0,.21.36.36,0,0,0,.08.12.14.14,0,0,0,.11,0,.22.22,0,0,0,.13,0,.33.33,0,0,0,.13-.11.67.67,0,0,0,.12-.16.86.86,0,0,0,.07-.21A1,1,0,0,0,150.4,274.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,297a1,1,0,0,1,0-.23.73.73,0,0,1,.08-.25.76.76,0,0,1,.13-.23.49.49,0,0,1,.19-.16.25.25,0,0,1,.19-.06.14.14,0,0,1,.12.06.36.36,0,0,1,.08.15,1.28,1.28,0,0,1,0,.58c0,.11-.09.24-.16.39l-.46,1,.65-.37s.05,0,.05,0v0a.11.11,0,0,1-.05.1l-.8.46s0,0,0,0v0a.13.13,0,0,1,0-.06.36.36,0,0,1,0-.09l.5-1.07a1.54,1.54,0,0,0,.09-.19.64.64,0,0,0,.06-.16l0-.13s0-.09,0-.13a.39.39,0,0,0-.08-.28.18.18,0,0,0-.21,0,.61.61,0,0,0-.21.24,1.12,1.12,0,0,0-.09.37s0,.05,0,.06l0,0,0,0S146.71,297,146.71,297Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.81,296.57a1.84,1.84,0,0,1,0-.33,1.18,1.18,0,0,1,.08-.31.94.94,0,0,1,.14-.26.85.85,0,0,1,.22-.2.35.35,0,0,1,.22-.06.24.24,0,0,1,.14.1.48.48,0,0,1,.08.22,1.39,1.39,0,0,1,0,.3v.51a1.84,1.84,0,0,1,0,.33,1.09,1.09,0,0,1-.08.31.94.94,0,0,1-.14.26.85.85,0,0,1-.22.2.35.35,0,0,1-.22.06.24.24,0,0,1-.14-.1.63.63,0,0,1-.08-.22,1.39,1.39,0,0,1,0-.3Zm.82-.45a1,1,0,0,0-.09-.43c-.06-.09-.14-.1-.26,0a.68.68,0,0,0-.26.33,1.75,1.75,0,0,0-.08.54,1.85,1.85,0,0,0,0,.23,1.93,1.93,0,0,0,0,.24.93.93,0,0,0,.08.44c.06.08.15.09.26,0a.57.57,0,0,0,.26-.32,2,2,0,0,0,.09-.54v-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,296.84a.13.13,0,0,1,0,.09l0,0s0,0,0,0v-1.79l-.35.61s-.05,0-.06,0l0,0s0,0,0-.05a.11.11,0,0,1,0-.05l.42-.73,0,0,0,0,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51,294.22s0,0,0,0v.11a.35.35,0,0,0,0,.06l-.49,2.08a.14.14,0,0,0,0,.06l0,.05-.05,0h0a.07.07,0,0,1,0-.05v0l.5-2.12-.66.38s0,0,0,0v0a.11.11,0,0,1,0-.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,315.9a2.15,2.15,0,0,1,0-.23c0-.08.05-.16.08-.25a1.59,1.59,0,0,1,.13-.22.75.75,0,0,1,.19-.17.45.45,0,0,1,.19-.06.26.26,0,0,1,.13.06.34.34,0,0,1,.07.16.68.68,0,0,1,0,.21,1.08,1.08,0,0,1,0,.36,2,2,0,0,1-.16.39l-.45,1,.65-.38s0,0,0,0v0a.1.1,0,0,1,0,.09l-.8.46s0,0,0,0v0a.17.17,0,0,1,0-.07.31.31,0,0,1,0-.09l.5-1.07a1.07,1.07,0,0,0,.09-.19l.06-.15a.68.68,0,0,0,0-.14.53.53,0,0,0,0-.13.38.38,0,0,0-.07-.27c0-.05-.12,0-.22,0a.5.5,0,0,0-.21.24,1.06,1.06,0,0,0-.09.37.14.14,0,0,1,0,.06l0,0,0,0S146.46,315.94,146.46,315.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,315.47c0-.11,0-.22,0-.33a2.81,2.81,0,0,1,.08-.31,1.17,1.17,0,0,1,.15-.27.69.69,0,0,1,.22-.19.34.34,0,0,1,.22-.06.2.2,0,0,1,.14.1.56.56,0,0,1,.08.22,2.66,2.66,0,0,1,0,.3,4.17,4.17,0,0,1,0,.5c0,.11,0,.22,0,.33a1.57,1.57,0,0,1-.08.31.92.92,0,0,1-.14.26.83.83,0,0,1-.22.2.36.36,0,0,1-.22.06.22.22,0,0,1-.15-.1.63.63,0,0,1-.07-.22,1.39,1.39,0,0,1,0-.3Zm.81-.46a.79.79,0,0,0-.09-.43c-.05-.09-.14-.1-.25,0a.63.63,0,0,0-.26.33,1.44,1.44,0,0,0-.09.53v.48a.79.79,0,0,0,.09.43c.06.09.14.1.26,0a.61.61,0,0,0,.25-.33,1.44,1.44,0,0,0,.09-.53V315Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.24,315.73a.1.1,0,0,1,0,.09l0,0s0,0,0,0V314l-.35.62s0,.05-.06,0l0,0s0,0,0,0a.14.14,0,0,1,0-.06l.41-.73,0,0,0,0,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.52,315.05a1,1,0,0,1,.06-.36.86.86,0,0,1,.16-.3.23.23,0,0,1-.13-.11.57.57,0,0,1,0-.25,1.15,1.15,0,0,1,0-.26,1.45,1.45,0,0,1,.09-.22,1.56,1.56,0,0,1,.14-.19,1,1,0,0,1,.17-.13.47.47,0,0,1,.17-.07.29.29,0,0,1,.14,0,.25.25,0,0,1,.1.12.69.69,0,0,1,0,.22.73.73,0,0,1-.05.3,1,1,0,0,1-.12.25.21.21,0,0,1,.16.12.55.55,0,0,1,.06.29,1,1,0,0,1,0,.29,1.09,1.09,0,0,1-.1.25,1.16,1.16,0,0,1-.16.21.9.9,0,0,1-.19.15.51.51,0,0,1-.18.07.41.41,0,0,1-.16,0,.26.26,0,0,1-.1-.14A.55.55,0,0,1,149.52,315.05Zm.12-.07a.38.38,0,0,0,0,.16.16.16,0,0,0,.08.1.2.2,0,0,0,.11,0,.39.39,0,0,0,.14-.05.83.83,0,0,0,.15-.11.91.91,0,0,0,.11-.16,1,1,0,0,0,.08-.18.69.69,0,0,0,0-.2.4.4,0,0,0,0-.17.24.24,0,0,0-.08-.09.14.14,0,0,0-.11,0,.33.33,0,0,0-.15.05l-.14.11-.11.15a.82.82,0,0,0-.11.39Zm.05-1a.46.46,0,0,0,0,.14s0,.07.07.08a.11.11,0,0,0,.1,0,.28.28,0,0,0,.12,0,.4.4,0,0,0,.12-.1.64.64,0,0,0,.1-.13.65.65,0,0,0,.1-.32.26.26,0,0,0,0-.14.13.13,0,0,0-.06-.08.18.18,0,0,0-.1,0,.43.43,0,0,0-.13.05l-.12.09a.71.71,0,0,0-.1.14.52.52,0,0,0-.07.15A1,1,0,0,0,149.69,314Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,344.05a2,2,0,0,1,0-.23,1.29,1.29,0,0,1,.21-.48,1,1,0,0,1,.19-.17.32.32,0,0,1,.19-.05.16.16,0,0,1,.13.06.35.35,0,0,1,.07.15.78.78,0,0,1,0,.22,1.12,1.12,0,0,1,0,.36,2.69,2.69,0,0,1-.16.39l-.45,1,.65-.37s0,0,0,0v0a.11.11,0,0,1,0,.1l-.8.46s0,0,0,0v-.05a.13.13,0,0,1,0-.06.32.32,0,0,1,0-.09l.51-1.07.09-.19.06-.16a.59.59,0,0,0,0-.13.57.57,0,0,0,0-.13.39.39,0,0,0-.07-.28c-.05,0-.12,0-.22,0a.61.61,0,0,0-.21.24,1.06,1.06,0,0,0-.09.37.08.08,0,0,1,0,.06l0,0,0,0S146.55,344.08,146.55,344.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.65,343.61c0-.11,0-.22,0-.33a2.81,2.81,0,0,1,.08-.31,1.35,1.35,0,0,1,.15-.26.61.61,0,0,1,.22-.2.34.34,0,0,1,.22-.06.28.28,0,0,1,.14.1.63.63,0,0,1,.08.22,2.66,2.66,0,0,1,0,.3,4.34,4.34,0,0,1,0,.51c0,.11,0,.22,0,.33a1.57,1.57,0,0,1-.08.31,1.3,1.3,0,0,1-.14.26.79.79,0,0,1-.22.19.3.3,0,0,1-.22.06.24.24,0,0,1-.15-.09.63.63,0,0,1-.07-.22,1.45,1.45,0,0,1,0-.3Zm.81-.45a.76.76,0,0,0-.09-.43c-.05-.09-.14-.1-.25,0a.58.58,0,0,0-.26.33,1.45,1.45,0,0,0-.09.54V344a.83.83,0,0,0,.09.44c0,.08.14.09.26,0a.55.55,0,0,0,.25-.32,1.45,1.45,0,0,0,.09-.54v-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.33,343.88a.1.1,0,0,1,0,.09l0,0s0,0,0,0v-1.79l-.35.61s0,.05-.06,0l0,0a.07.07,0,0,1,0,0,.17.17,0,0,1,0-.05l.41-.73,0,0h0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5,341.83a.91.91,0,0,1,0,.17l0,.16s0,.09,0,.13a.36.36,0,0,1,0,.11l-.4,1.11,0,.05,0,0,0,0h0a.05.05,0,0,1,0,0v0h0l.31-.85-.12.1a.36.36,0,0,1-.21,0,.19.19,0,0,1-.14-.07.39.39,0,0,1-.09-.17.85.85,0,0,1,0-.23,1.24,1.24,0,0,1,0-.27,1.43,1.43,0,0,1,.09-.27,1,1,0,0,1,.14-.24.6.6,0,0,1,.21-.18.27.27,0,0,1,.2-.06.18.18,0,0,1,.14.08.39.39,0,0,1,.09.17A.85.85,0,0,1,150.5,341.83Zm-.8.47a1,1,0,0,0,0,.19.36.36,0,0,0,.08.12.14.14,0,0,0,.11,0,.24.24,0,0,0,.13,0l.13-.11a1,1,0,0,0,.1-.17.7.7,0,0,0,.08-.2.85.85,0,0,0,0-.23.6.6,0,0,0,0-.2.19.19,0,0,0-.08-.11.13.13,0,0,0-.1,0,.2.2,0,0,0-.13,0,.33.33,0,0,0-.13.11.46.46,0,0,0-.11.16,1,1,0,0,0-.08.21A1.64,1.64,0,0,0,149.7,342.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,360.86c0-.06,0-.14,0-.22a1.29,1.29,0,0,1,.21-.48.77.77,0,0,1,.19-.17.45.45,0,0,1,.19-.06.24.24,0,0,1,.13.07.35.35,0,0,1,.07.15,1.49,1.49,0,0,1,0,.21,1.36,1.36,0,0,1,0,.36,3.69,3.69,0,0,1-.16.4l-.46,1,.66-.37s0,0,0,0v0c0,.05,0,.08,0,.09l-.8.47s0,0,0-.05v0s0,0,0-.06a.36.36,0,0,1,0-.09l.51-1.07a2,2,0,0,1,.09-.2.88.88,0,0,0,0-.15.35.35,0,0,0,0-.13.57.57,0,0,0,0-.13.39.39,0,0,0-.08-.28s-.12,0-.21,0a.5.5,0,0,0-.21.24,1.06,1.06,0,0,0-.09.37.11.11,0,0,1,0,.06s0,0,0,0l0,0S146.14,360.9,146.14,360.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,360.43c0-.11,0-.22,0-.33a1.57,1.57,0,0,1,.08-.31,1.3,1.3,0,0,1,.14-.26.83.83,0,0,1,.22-.2.38.38,0,0,1,.23-.06.26.26,0,0,1,.14.1.63.63,0,0,1,.07.22,1.39,1.39,0,0,1,0,.3,4.17,4.17,0,0,1,0,.5,1.69,1.69,0,0,1,0,.33,1.41,1.41,0,0,1-.07.31,1.71,1.71,0,0,1-.14.27.71.71,0,0,1-.23.19.34.34,0,0,1-.22.06.2.2,0,0,1-.14-.1.68.68,0,0,1-.08-.22,2.51,2.51,0,0,1,0-.3A4.17,4.17,0,0,1,147.25,360.43Zm.81-.45a.76.76,0,0,0-.09-.43c-.06-.09-.14-.1-.26,0a.61.61,0,0,0-.25.33,1.45,1.45,0,0,0-.09.54v.47a.76.76,0,0,0,.09.43c0,.09.14.1.25,0A.53.53,0,0,0,148,361a1.45,1.45,0,0,0,.09-.54V360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,359.54a1,1,0,0,1,0-.23,1.44,1.44,0,0,1,.08-.25,1,1,0,0,1,.13-.22.61.61,0,0,1,.19-.17.45.45,0,0,1,.19-.06.26.26,0,0,1,.13.06.34.34,0,0,1,.07.16.68.68,0,0,1,0,.21,1,1,0,0,1-.05.36,2,2,0,0,1-.16.39l-.46,1,.66-.38s0,0,0,0v.05a.1.1,0,0,1,0,.09l-.8.46s0,0,0,0v0a.2.2,0,0,1,0-.07.92.92,0,0,1,0-.09l.51-1.07c0-.07.06-.13.09-.19a.88.88,0,0,0,.05-.15.35.35,0,0,0,0-.14.53.53,0,0,0,0-.13.38.38,0,0,0-.07-.27c-.05,0-.12,0-.22,0a.5.5,0,0,0-.21.24,1.06,1.06,0,0,0-.09.37.14.14,0,0,1,0,.06s0,0,0,0l0,0S148.44,359.58,148.44,359.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.54,359.11c0-.11,0-.22,0-.33a2.81,2.81,0,0,1,.08-.31,1.26,1.26,0,0,1,.14-.26.74.74,0,0,1,.23-.2.34.34,0,0,1,.22-.06.2.2,0,0,1,.14.1.79.79,0,0,1,.08.22,2.66,2.66,0,0,1,0,.3,4.17,4.17,0,0,1,0,.5c0,.11,0,.22,0,.33a2.81,2.81,0,0,1-.08.31.92.92,0,0,1-.14.26.83.83,0,0,1-.22.2.38.38,0,0,1-.23.06.22.22,0,0,1-.14-.1.79.79,0,0,1-.08-.22,2.66,2.66,0,0,1,0-.3Zm.81-.46a.79.79,0,0,0-.09-.43c0-.08-.14-.1-.25,0a.58.58,0,0,0-.26.33,1.44,1.44,0,0,0-.09.53v.48a.76.76,0,0,0,.09.43c.05.09.14.1.26,0a.61.61,0,0,0,.25-.33,1.4,1.4,0,0,0,.09-.53v-.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57,386.44a1,1,0,0,1,0-.23,1.09,1.09,0,0,1,.07-.24,1.71,1.71,0,0,1,.13-.23.75.75,0,0,1,.19-.17.45.45,0,0,1,.19-.06.23.23,0,0,1,.13.06.26.26,0,0,1,.07.16.66.66,0,0,1,0,.21,1,1,0,0,1-.06.36,1.53,1.53,0,0,1-.16.39l-.45,1,.65-.38s.05,0,.05,0v0a.09.09,0,0,1-.05.09l-.8.46s0,0,0,0v0a.2.2,0,0,1,0-.07l0-.09.5-1.06a1.59,1.59,0,0,0,.09-.2.94.94,0,0,0,.06-.15l0-.14V386a.38.38,0,0,0-.07-.27c-.05-.05-.12,0-.22,0a.56.56,0,0,0-.21.24,1.34,1.34,0,0,0-.09.37.14.14,0,0,1,0,.06s0,0,0,0l0,0S146.57,386.48,146.57,386.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.67,386a1.84,1.84,0,0,1,0-.33,1.55,1.55,0,0,1,.07-.31.93.93,0,0,1,.15-.26.7.7,0,0,1,.22-.2.35.35,0,0,1,.22-.06.18.18,0,0,1,.14.1.63.63,0,0,1,.08.22,1.39,1.39,0,0,1,0,.3v.5c0,.11,0,.22,0,.33a1.57,1.57,0,0,1-.08.31.87.87,0,0,1-.14.27.67.67,0,0,1-.22.19.35.35,0,0,1-.22.06.18.18,0,0,1-.14-.1.44.44,0,0,1-.08-.22,1.39,1.39,0,0,1,0-.3Zm.81-.46a.91.91,0,0,0-.08-.43.18.18,0,0,0-.26,0,.63.63,0,0,0-.26.33,2,2,0,0,0-.09.53v.48a1,1,0,0,0,.09.43c.06.09.14.1.26,0a.63.63,0,0,0,.26-.33,1.64,1.64,0,0,0,.08-.53,2.88,2.88,0,0,0,0-.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86,385.12a1,1,0,0,1,0-.23,1.17,1.17,0,0,1,.07-.25,1,1,0,0,1,.14-.22.52.52,0,0,1,.19-.17.38.38,0,0,1,.19-.06.14.14,0,0,1,.12.06.36.36,0,0,1,.08.15,1.28,1.28,0,0,1,0,.58,2.93,2.93,0,0,1-.16.39l-.46,1,.65-.38s0,0,0,0v.05a.11.11,0,0,1,0,.09l-.8.46s0,0,0,0v-.05a.13.13,0,0,1,0-.06l0-.09.5-1.07a1.54,1.54,0,0,0,.09-.19c0-.06,0-.11.06-.15l0-.14v-.13a.38.38,0,0,0-.07-.27c-.05-.05-.12-.05-.21,0a.5.5,0,0,0-.21.24,1.06,1.06,0,0,0-.1.37.13.13,0,0,1,0,.06l0,0,0,0S148.86,385.16,148.86,385.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,385.64c0,.05,0,.08,0,.09l0,0s-.05,0-.05,0v-1.78l-.34.61s0,0-.06,0l0,0s0,0,0,0,0,0,0-.05l.42-.74,0,0,0,0,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,256,186,243.21c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8L163.8,258.37c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,163.8,256Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,256,186,243.21c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8L163.8,258.37c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,163.8,256Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,264.19a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68L195,244.49a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68L163,264.12A.47.47,0,0,1,162.72,264.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,386,186,373.13c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,388.3c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,386Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,386,186,373.13c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,388.3c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,386Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,394.11a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,374.42a.51.51,0,0,1,.69.18.5.5,0,0,1-.19.68L163,394.05A.57.57,0,0,1,162.72,394.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,341.39,186,328.57c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,343.74c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,341.39Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,341.39,186,328.57c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,343.74c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,341.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,349.55a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,329.86a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68L163,349.49A.57.57,0,0,1,162.72,349.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,311.64,186,298.81c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,314c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,163.8,311.64Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,311.64,186,298.81c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,314c-.6.35-1.08.1-1.08-.55A2.3,2.3,0,0,1,163.8,311.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,319.79a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,300.1a.5.5,0,1,1,.5.87L163,319.73A.57.57,0,0,1,162.72,319.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,272.44,186,259.62c.6-.34,1.08-.1,1.08.55A2.32,2.32,0,0,1,186,262L163.8,274.79c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,272.44Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,272.44,186,259.62c.6-.34,1.08-.1,1.08.55A2.32,2.32,0,0,1,186,262L163.8,274.79c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,272.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,280.6a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,260.91a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68L163,280.54A.57.57,0,0,1,162.72,280.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,284.83a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69L195,265.13a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68L163,284.76A.47.47,0,0,1,162.72,284.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,292.38,186,279.56c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8L163.8,294.72c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,163.8,292.38Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,292.38,186,279.56c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8L163.8,294.72c-.6.35-1.08.1-1.08-.54A2.31,2.31,0,0,1,163.8,292.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,300.54a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69L195,280.84a.5.5,0,1,1,.5.87L163,300.47A.59.59,0,0,1,162.72,300.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,304.76a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,285.07a.51.51,0,0,1,.69.18.5.5,0,0,1-.19.68L163,304.69A.47.47,0,0,1,162.72,304.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,323.59,186,310.77c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,325.94c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,323.59Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,323.59,186,310.77c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,325.94c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,323.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,331.75a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,312.06a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68L163,331.69A.57.57,0,0,1,162.72,331.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,336a.51.51,0,0,1-.44-.25.5.5,0,0,1,.19-.68L195,316.28a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68L163,335.91A.47.47,0,0,1,162.72,336Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,356.75,186,343.93c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,359.1c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,356.75Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,356.75,186,343.93c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,359.1c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,356.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,364.91a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,345.22a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68L163,364.85A.57.57,0,0,1,162.72,364.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,368.71,186,355.89c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,371.06c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,368.71Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,368.71,186,355.89c.6-.34,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L163.8,371.06c-.6.34-1.08.1-1.08-.55A2.32,2.32,0,0,1,163.8,368.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,376.87a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68L195,357.18a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68L163,376.8A.47.47,0,0,1,162.72,376.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,381.1a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69L195,361.4a.5.5,0,1,1,.5.87L163,381A.47.47,0,0,1,162.72,381.1Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M201.17,481.94a4.12,4.12,0,0,1-4-3.32l-.68-3.56a43,43,0,0,1-4.54-1.13L185,477.14a4.72,4.72,0,0,1-2,.42,4.8,4.8,0,0,1-2.37-.61l-7.09-4.1a3.52,3.52,0,0,1-.31-6l3.72-2.67c-.17-.26-.34-.52-.5-.78l-8.66-.55a4,4,0,0,1-3.7-3.93v-5.28a4,4,0,0,1,3.7-3.93l8.66-.55c.16-.26.33-.52.5-.78l-3.71-2.67a3.52,3.52,0,0,1,.3-6l7.09-4.09a4.8,4.8,0,0,1,2.37-.61,4.53,4.53,0,0,1,2,.42l6.93,3.2a45.61,45.61,0,0,1,4.54-1.12l.68-3.57a4.13,4.13,0,0,1,4-3.31h10.43a4.11,4.11,0,0,1,4,3.31l.68,3.57a44.94,44.94,0,0,1,4.54,1.12l6.93-3.21a4.68,4.68,0,0,1,2-.41,4.8,4.8,0,0,1,2.37.61l7.1,4.09a3.53,3.53,0,0,1,.3,6l-3.72,2.67c.17.26.34.52.5.78l8.66.55a4,4,0,0,1,3.7,3.93v5.28a4,4,0,0,1-3.69,3.93l-8.67.55c-.16.26-.33.52-.5.77l3.71,2.68a3.52,3.52,0,0,1-.3,6L232.08,477a4.8,4.8,0,0,1-2.37.61h0a4.72,4.72,0,0,1-2-.42l-6.93-3.21a41.83,41.83,0,0,1-4.54,1.13l-.68,3.57a4.12,4.12,0,0,1-4,3.31Zm5.22-32.44A21.59,21.59,0,0,0,195.91,452c-2.21,1.27-3.47,2.84-3.47,4.32s1.26,3,3.47,4.32a23.55,23.55,0,0,0,21,0c2.2-1.27,3.47-2.85,3.47-4.32s-1.27-3.05-3.47-4.32A21.59,21.59,0,0,0,206.39,449.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,436.17l-7.1-4.09A1.91,1.91,0,0,0,229,432l-7.19,3.34a2.63,2.63,0,0,1-1.64.09,41.79,41.79,0,0,0-5.59-1.32,1.37,1.37,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H201.18a1.13,1.13,0,0,0-1.06.87l-.9,4.74a1.35,1.35,0,0,1-1,1,42.15,42.15,0,0,0-5.59,1.32,2.63,2.63,0,0,1-1.64-.09L183.77,432a1.87,1.87,0,0,0-1.57.07l-7.09,4.09a.57.57,0,0,0-.33.48h0v6.15h0a.6.6,0,0,0,.28.48l3.26,2.35a1.6,1.6,0,0,1-.8.33l-9.45.6a1,1,0,0,0-.89.94v4h0v7.39a1,1,0,0,0,.88.94l9.45.6a1.61,1.61,0,0,1,.82.35l-3.24,2.34a.57.57,0,0,0-.28.47h0v6.15h0a.56.56,0,0,0,.33.48l7.09,4.1a1.91,1.91,0,0,0,1.57.07l7.19-3.33a2.59,2.59,0,0,1,1.65-.1,43.25,43.25,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1,.87h10.43a1.1,1.1,0,0,0,1-.86l.9-4.74a1.34,1.34,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.56,2.56,0,0,1,1.64.1l7.19,3.33a1.91,1.91,0,0,0,1.57-.07l7.1-4.1a.59.59,0,0,0,.33-.47h0l0-6.16h0a.57.57,0,0,0-.28-.47l-3.26-2.35a1.56,1.56,0,0,1,.8-.34l9.46-.6a1,1,0,0,0,.88-.94V447.5a1,1,0,0,0-.89-.94l-9.45-.6a1.53,1.53,0,0,1-.82-.35l3.25-2.33a.6.6,0,0,0,.28-.47h0l0-6.16h0A.62.62,0,0,0,237.68,436.17ZM189.79,452.1c.51-1.7,2-3.36,4.61-4.85,6.62-3.83,17.35-3.83,24,0a11,11,0,0,1,4.73,4.52c-.57,1.93-2.14,3.79-4.73,5.29-6.61,3.82-17.35,3.82-24,0A9.8,9.8,0,0,1,189.79,452.1Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,436.17l-7.1-4.09A1.91,1.91,0,0,0,229,432l-7.19,3.34a2.63,2.63,0,0,1-1.64.09,41.79,41.79,0,0,0-5.59-1.32,1.37,1.37,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H201.18a1.13,1.13,0,0,0-1.06.87l-.9,4.74a1.35,1.35,0,0,1-1,1,42.15,42.15,0,0,0-5.59,1.32,2.63,2.63,0,0,1-1.64-.09L183.77,432a1.87,1.87,0,0,0-1.57.07l-7.09,4.09a.57.57,0,0,0-.33.48h0v6.15h0a.6.6,0,0,0,.28.48l3.26,2.35a1.6,1.6,0,0,1-.8.33l-9.45.6a1,1,0,0,0-.89.94v4h0v7.39a1,1,0,0,0,.88.94l9.45.6a1.61,1.61,0,0,1,.82.35l-3.24,2.34a.57.57,0,0,0-.28.47h0v6.15h0a.56.56,0,0,0,.33.48l7.09,4.1a1.91,1.91,0,0,0,1.57.07l7.19-3.33a2.59,2.59,0,0,1,1.65-.1,43.25,43.25,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1,.87h10.43a1.1,1.1,0,0,0,1-.86l.9-4.74a1.34,1.34,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.56,2.56,0,0,1,1.64.1l7.19,3.33a1.91,1.91,0,0,0,1.57-.07l7.1-4.1a.59.59,0,0,0,.33-.47h0l0-6.16h0a.57.57,0,0,0-.28-.47l-3.26-2.35a1.56,1.56,0,0,1,.8-.34l9.46-.6a1,1,0,0,0,.88-.94V447.5a1,1,0,0,0-.89-.94l-9.45-.6a1.53,1.53,0,0,1-.82-.35l3.25-2.33a.6.6,0,0,0,.28-.47h0l0-6.16h0A.62.62,0,0,0,237.68,436.17ZM189.79,452.1c.51-1.7,2-3.36,4.61-4.85,6.62-3.83,17.35-3.83,24,0a11,11,0,0,1,4.73,4.52c-.57,1.93-2.14,3.79-4.73,5.29-6.61,3.82-17.35,3.82-24,0A9.8,9.8,0,0,1,189.79,452.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,455.16a1.74,1.74,0,0,0-1.27-.85l-9.46-.59a1,1,0,0,1-.88-1v-1.24l0,7.39a1,1,0,0,0,.89.95l9.45.59a1.62,1.62,0,0,1,.83.34l2.37-1.7a.74.74,0,0,0,.1-1.15A14.5,14.5,0,0,1,178.77,455.16Zm-4-12.36h0a.58.58,0,0,0,.28.47l3.26,2.35a1.54,1.54,0,0,0,.47-.52,14.44,14.44,0,0,1,2-2.78.76.76,0,0,0-.1-1.16l-5.63-4a.71.71,0,0,1-.28-.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.37,443.22c-6.62-3.82-17.34-3.82-24,0-4.19,2.41-5.73,5.78-4.62,8.89.5-1.7,2-3.37,4.61-4.87,6.62-3.82,17.35-3.81,24,0a11,11,0,0,1,4.73,4.51C224,448.75,222.4,445.55,218.37,443.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,452.9a1,1,0,0,1-.87.82l-9.45.59a1.37,1.37,0,0,0-.48.13v6.16a1.35,1.35,0,0,1,.46-.14l9.46-.6a1,1,0,0,0,.88-.93ZM238,436.65h0a.44.44,0,0,1,0,.19.47.47,0,0,1-.12.18.69.69,0,0,1-.13.11l-5.62,4a.53.53,0,0,0-.13.13.63.63,0,0,0-.18.34.65.65,0,0,0,0,.24c0,.05,0,.08,0,.12a.79.79,0,0,0,.19.33l.1.12a14.29,14.29,0,0,1,1.91,2.66,1.9,1.9,0,0,0,.44.51l3.26-2.34a.63.63,0,0,0,.28-.47h0Zm0,27a.66.66,0,0,1-.33.44l-7.1,4.09a1.83,1.83,0,0,1-1.1.19v6.15a1.87,1.87,0,0,0,1.09-.19l7.1-4.1a.57.57,0,0,0,.33-.46Zm-46.34,1.1a2.06,2.06,0,0,0-.71.17l-7.19,3.33a1.63,1.63,0,0,1-.64.14l0,6.14a2.21,2.21,0,0,0,.65-.13l7.18-3.33a2.24,2.24,0,0,1,.71-.17Zm20.81,7.55a1.09,1.09,0,0,1-.87.46H201.17a1.1,1.1,0,0,1-.63-.23v6.15a1.1,1.1,0,0,0,.63.23h10.42a1.13,1.13,0,0,0,.92-.53Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,452.9a1,1,0,0,1-.87.82l-9.45.59a1.37,1.37,0,0,0-.48.13v6.16a1.35,1.35,0,0,1,.46-.14l9.46-.6a1,1,0,0,0,.88-.93ZM238,436.65h0a.44.44,0,0,1,0,.19.47.47,0,0,1-.12.18.69.69,0,0,1-.13.11l-5.62,4a.53.53,0,0,0-.13.13.63.63,0,0,0-.18.34.65.65,0,0,0,0,.24c0,.05,0,.08,0,.12a.79.79,0,0,0,.19.33l.1.12a14.29,14.29,0,0,1,1.91,2.66,1.9,1.9,0,0,0,.44.51l3.26-2.34a.63.63,0,0,0,.28-.47h0Zm0,27a.66.66,0,0,1-.33.44l-7.1,4.09a1.83,1.83,0,0,1-1.1.19v6.15a1.87,1.87,0,0,0,1.09-.19l7.1-4.1a.57.57,0,0,0,.33-.46Zm-46.34,1.1a2.06,2.06,0,0,0-.71.17l-7.19,3.33a1.63,1.63,0,0,1-.64.14l0,6.14a2.21,2.21,0,0,0,.65-.13l7.18-3.33a2.24,2.24,0,0,1,.71-.17Zm20.81,7.55a1.09,1.09,0,0,1-.87.46H201.17a1.1,1.1,0,0,1-.63-.23v6.15a1.1,1.1,0,0,0,.63.23h10.42a1.13,1.13,0,0,0,.92-.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,432l-7.19,3.34a2.63,2.63,0,0,1-1.64.09,41.79,41.79,0,0,0-5.59-1.32,1.37,1.37,0,0,1-1-1l-.89-4.74a1.13,1.13,0,0,0-1.06-.87H201.18a1.13,1.13,0,0,0-1.06.87l-.9,4.74a1.35,1.35,0,0,1-1,1,42.15,42.15,0,0,0-5.59,1.32,2.63,2.63,0,0,1-1.64-.09L183.77,432a1.87,1.87,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0-.05,1l5.62,4.05a.74.74,0,0,1,.1,1.15,14,14,0,0,0-2,2.78,1.76,1.76,0,0,1-1.28.85l-9.45.6a1,1,0,0,0-.89.94v5.27a1,1,0,0,0,.89,1l9.45.59a1.76,1.76,0,0,1,1.28.85,13.73,13.73,0,0,0,2,2.79.74.74,0,0,1-.1,1.15l-5.62,4a.52.52,0,0,0,.05,1l7.09,4.1a1.91,1.91,0,0,0,1.57.07l7.19-3.33a2.63,2.63,0,0,1,1.64-.1,43.4,43.4,0,0,0,5.59,1.33,1.35,1.35,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1,.87H211.6a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.37,1.37,0,0,1,1-1,43.8,43.8,0,0,0,5.59-1.33,2.63,2.63,0,0,1,1.64.1l7.19,3.33a1.91,1.91,0,0,0,1.57-.07l7.09-4.1a.52.52,0,0,0,.05-1l-5.62-4A.74.74,0,0,1,232,458a13.73,13.73,0,0,0,2-2.79,1.76,1.76,0,0,1,1.28-.85l9.45-.59a1,1,0,0,0,.89-1V447.5a1,1,0,0,0-.89-.94l-9.45-.6a1.76,1.76,0,0,1-1.28-.85,14,14,0,0,0-2-2.78.74.74,0,0,1,.1-1.15l5.62-4.05a.53.53,0,0,0,0-1l-7.1-4.09A1.91,1.91,0,0,0,229,432Zm-10.64,11.22c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S211.76,439.4,218.37,443.22Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,432l-7.19,3.34a2.63,2.63,0,0,1-1.64.09,41.79,41.79,0,0,0-5.59-1.32,1.37,1.37,0,0,1-1-1l-.89-4.74a1.13,1.13,0,0,0-1.06-.87H201.18a1.13,1.13,0,0,0-1.06.87l-.9,4.74a1.35,1.35,0,0,1-1,1,42.15,42.15,0,0,0-5.59,1.32,2.63,2.63,0,0,1-1.64-.09L183.77,432a1.87,1.87,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0-.05,1l5.62,4.05a.74.74,0,0,1,.1,1.15,14,14,0,0,0-2,2.78,1.76,1.76,0,0,1-1.28.85l-9.45.6a1,1,0,0,0-.89.94v5.27a1,1,0,0,0,.89,1l9.45.59a1.76,1.76,0,0,1,1.28.85,13.73,13.73,0,0,0,2,2.79.74.74,0,0,1-.1,1.15l-5.62,4a.52.52,0,0,0,.05,1l7.09,4.1a1.91,1.91,0,0,0,1.57.07l7.19-3.33a2.63,2.63,0,0,1,1.64-.1,43.4,43.4,0,0,0,5.59,1.33,1.35,1.35,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1,.87H211.6a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.37,1.37,0,0,1,1-1,43.8,43.8,0,0,0,5.59-1.33,2.63,2.63,0,0,1,1.64.1l7.19,3.33a1.91,1.91,0,0,0,1.57-.07l7.09-4.1a.52.52,0,0,0,.05-1l-5.62-4A.74.74,0,0,1,232,458a13.73,13.73,0,0,0,2-2.79,1.76,1.76,0,0,1,1.28-.85l9.45-.59a1,1,0,0,0,.89-1V447.5a1,1,0,0,0-.89-.94l-9.45-.6a1.76,1.76,0,0,1-1.28-.85,14,14,0,0,0-2-2.78.74.74,0,0,1,.1-1.15l5.62-4.05a.53.53,0,0,0,0-1l-7.1-4.09A1.91,1.91,0,0,0,229,432Zm-10.64,11.22c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S211.76,439.4,218.37,443.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,473.13H201.17a1.46,1.46,0,0,1-1.39-1.15l-.9-4.74a1,1,0,0,0-.75-.73,42.1,42.1,0,0,1-5.63-1.34,2.31,2.31,0,0,0-1.4.09l-7.19,3.33a2.27,2.27,0,0,1-1.89-.09l-7.09-4.09a.91.91,0,0,1-.5-.75.94.94,0,0,1,.42-.8l5.63-4a.48.48,0,0,0,.18-.29.5.5,0,0,0-.13-.35,14.67,14.67,0,0,1-2.06-2.85,1.39,1.39,0,0,0-1-.67l-9.46-.6a1.31,1.31,0,0,1-1.21-1.29V447.5a1.32,1.32,0,0,1,1.21-1.29l9.46-.6a1.38,1.38,0,0,0,1-.66,14.73,14.73,0,0,1,2.06-2.86.46.46,0,0,0,.13-.34.43.43,0,0,0-.18-.29l-5.63-4a.88.88,0,0,1,.08-1.54l7.09-4.1a2.29,2.29,0,0,1,1.9-.08l7.19,3.33a2.2,2.2,0,0,0,1.39.08,45.42,45.42,0,0,1,5.63-1.34,1,1,0,0,0,.75-.73l.9-4.74a1.47,1.47,0,0,1,1.4-1.15H211.6a1.47,1.47,0,0,1,1.4,1.15l.9,4.74a1,1,0,0,0,.75.73,45.42,45.42,0,0,1,5.63,1.34,2.2,2.2,0,0,0,1.39-.08l7.19-3.33a2.27,2.27,0,0,1,1.89.08l7.1,4.1a.94.94,0,0,1,.5.75.91.91,0,0,1-.42.79l-5.63,4a.43.43,0,0,0-.18.29.46.46,0,0,0,.13.34,14.73,14.73,0,0,1,2.06,2.86,1.38,1.38,0,0,0,1,.66l9.46.6A1.31,1.31,0,0,1,246,447.5v5.27a1.31,1.31,0,0,1-1.21,1.29l-9.46.6a1.39,1.39,0,0,0-1,.67,14.37,14.37,0,0,1-2.06,2.85.5.5,0,0,0-.13.35.48.48,0,0,0,.18.29l5.63,4a.88.88,0,0,1-.08,1.55l-7.1,4.09a2.25,2.25,0,0,1-1.88.09l-7.2-3.33a2.27,2.27,0,0,0-1.39-.09,42.1,42.1,0,0,1-5.63,1.34,1,1,0,0,0-.75.73L213,472A1.46,1.46,0,0,1,211.6,473.13Zm-19.66-8.73a2.65,2.65,0,0,1,.77.11,42.55,42.55,0,0,0,5.53,1.32,1.71,1.71,0,0,1,1.33,1.28l.9,4.74a.75.75,0,0,0,.7.59H211.6a.76.76,0,0,0,.71-.59l.9-4.74a1.71,1.71,0,0,1,1.32-1.28,42.31,42.31,0,0,0,5.54-1.32,2.94,2.94,0,0,1,1.9.11l7.19,3.33a1.56,1.56,0,0,0,1.25-.05l7.09-4.1c.1-.05.16-.12.16-.18a.28.28,0,0,0-.14-.19l-5.62-4.05a1.08,1.08,0,0,1-.47-.78,1.17,1.17,0,0,1,.31-.89,14,14,0,0,0,2-2.71,2.07,2.07,0,0,1,1.56-1l9.45-.6a.62.62,0,0,0,.56-.6V447.5a.61.61,0,0,0-.56-.59l-9.45-.6a2.1,2.1,0,0,1-1.56-1,14,14,0,0,0-2-2.72,1.14,1.14,0,0,1-.31-.88,1.1,1.1,0,0,1,.47-.79l5.62-4c.09-.07.14-.14.14-.2s-.06-.12-.16-.18l-7.09-4.09a1.56,1.56,0,0,0-1.25-.06L222,435.65a3,3,0,0,1-1.9.12,42.55,42.55,0,0,0-5.53-1.32,1.72,1.72,0,0,1-1.33-1.29l-.9-4.74a.76.76,0,0,0-.71-.58H201.18a.76.76,0,0,0-.71.58l-.9,4.74a1.72,1.72,0,0,1-1.33,1.29,42.55,42.55,0,0,0-5.53,1.32,3,3,0,0,1-1.9-.12l-7.19-3.33a1.56,1.56,0,0,0-1.25.06l-7.09,4.09c-.1.06-.16.13-.16.18s0,.13.14.2l5.62,4a1.1,1.1,0,0,1,.47.79,1.14,1.14,0,0,1-.31.88,14,14,0,0,0-2,2.72,2.1,2.1,0,0,1-1.56,1l-9.45.6a.6.6,0,0,0-.56.59v5.27a.62.62,0,0,0,.56.6l9.45.6a2.07,2.07,0,0,1,1.56,1,14,14,0,0,0,2,2.71,1.15,1.15,0,0,1,.31.89,1.08,1.08,0,0,1-.47.78l-5.62,4.05a.28.28,0,0,0-.14.19c0,.06.06.13.16.18l7.09,4.1a1.56,1.56,0,0,0,1.25.05l7.19-3.33A2.88,2.88,0,0,1,191.94,464.4Zm14.45-4.14a24.93,24.93,0,0,1-12.16-2.9c-3.31-1.91-5.14-4.48-5.14-7.22s1.83-5.31,5.14-7.22c6.71-3.87,17.61-3.87,24.32,0h0c3.31,1.91,5.14,4.48,5.14,7.22s-1.83,5.31-5.14,7.22A24.93,24.93,0,0,1,206.39,460.26Zm0-19.56a24.15,24.15,0,0,0-11.81,2.82c-3.09,1.78-4.79,4.13-4.79,6.62s1.7,4.83,4.79,6.62c6.51,3.75,17.11,3.75,23.62,0,3.09-1.79,4.79-4.14,4.79-6.62s-1.7-4.84-4.79-6.62A24.15,24.15,0,0,0,206.39,440.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M254.5,436.65a3.15,3.15,0,0,1-.44,0L247.9,436a4.07,4.07,0,0,1-3.62-4.54l.11-.95c-.52-.19-1-.39-1.52-.61,0,0,0,0,0,0h-.07l-4.68,1.47a4.67,4.67,0,0,1-1.41.21,5.23,5.23,0,0,1-3.29-1.14l-3.14-2.62a3.65,3.65,0,0,1,.71-6.18l1.06-.53-2.88-.5a3.92,3.92,0,0,1-3.11-5.08l.85-2.72a4.54,4.54,0,0,1,4.24-3.1l5.23.2-.67-.71a3.69,3.69,0,0,1,1.33-6.05l4.93-2a5,5,0,0,1,1.83-.34,5.24,5.24,0,0,1,2.87.82l3.19,2.12h0c.92-.16,1.86-.28,2.8-.37l1-1.85a4.71,4.71,0,0,1,4.12-2.5l.45,0,6.15.64a4.07,4.07,0,0,1,3.62,4.54l-.11,1c.52.19,1,.39,1.52.61,0,0,0,0,0,0h.08l4.67-1.47a4.69,4.69,0,0,1,1.42-.21,5.22,5.22,0,0,1,3.28,1.14L282,407.9a3.65,3.65,0,0,1-.71,6.18l-1.06.53,2.88.49a3.94,3.94,0,0,1,3.11,5.09l-.85,2.72a4.53,4.53,0,0,1-4.24,3.1l-5.23-.2.67.71a3.69,3.69,0,0,1-1.33,6.05l-4.93,2a5,5,0,0,1-1.83.34,5.24,5.24,0,0,1-2.87-.82l-3.19-2.12h0c-.91.16-1.85.28-2.8.37l-1,1.85A4.73,4.73,0,0,1,254.5,436.65Zm1.62-22.59a15.18,15.18,0,0,0-5.57,1c-2.16.87-3.06,2-3.16,2.65s.58,1.36,1,1.71c1.65,1.37,4.62,2.22,7.75,2.22a15.16,15.16,0,0,0,5.58-1c2.16-.87,3.06-2,3.16-2.65s-.58-1.36-1-1.71C262.23,414.92,259.26,414.06,256.12,414.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,402.49a1.33,1.33,0,0,1-.92-1.39l.28-2.33a1.06,1.06,0,0,0-.95-1.2l-6.16-.65a1.72,1.72,0,0,0-1.58.86l-1.23,2.39a2.14,2.14,0,0,1-1.59,1,30.54,30.54,0,0,0-3.19.4,3.21,3.21,0,0,1-2-.4L245,399a2.37,2.37,0,0,0-1.93-.2l-4.92,2a.72.72,0,0,0-.51.63h0v.06h0v5h0a.82.82,0,0,0,.24.56l.29.3a2.54,2.54,0,0,1-1.36.42l-5.62-.23a1.54,1.54,0,0,0-1.43,1l-.85,2.72a1.34,1.34,0,0,0,0,.34h0v5.08h0a.92.92,0,0,0,.79.88l4.36.75-1.7.85a.72.72,0,0,0-.44.62h0v5.09h0a.74.74,0,0,0,.31.56l3.14,2.61a2.22,2.22,0,0,0,1.88.38l4.79-1.5a3.39,3.39,0,0,1,2,.13c.82.35,1.68.67,2.57.95a1.21,1.21,0,0,1,.63.44v3.43h0a1.06,1.06,0,0,0,1,1.05l6.16.65a1.71,1.71,0,0,0,1.58-.87l1.23-2.38a2.14,2.14,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.21,3.21,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.73.73,0,0,0,.51-.66h0V424h0a.84.84,0,0,0-.24-.55l-.29-.3a2.54,2.54,0,0,1,1.36-.42l5.62.23a1.51,1.51,0,0,0,1.42-1l.86-2.72a1.15,1.15,0,0,0,0-.31h0v-5.06h0a.91.91,0,0,0-.78-.94l-4.36-.75,1.7-.85a.7.7,0,0,0,.44-.63h0v-5.06h0a.76.76,0,0,0-.31-.59l-3.14-2.61a2.24,2.24,0,0,0-1.89-.38l-4.78,1.5a3.39,3.39,0,0,1-2-.13C267.4,403.09,266.54,402.77,265.65,402.49Zm-20.42,12.75a9.11,9.11,0,0,1,4.2-3c5.34-2.14,12.67-1.37,16.37,1.71a7.59,7.59,0,0,1,1.25,1.32,9.12,9.12,0,0,1-4.21,3.06c-5.34,2.14-12.67,1.37-16.37-1.71A7,7,0,0,1,245.23,415.24Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,402.49a1.33,1.33,0,0,1-.92-1.39l.28-2.33a1.06,1.06,0,0,0-.95-1.2l-6.16-.65a1.72,1.72,0,0,0-1.58.86l-1.23,2.39a2.14,2.14,0,0,1-1.59,1,30.54,30.54,0,0,0-3.19.4,3.21,3.21,0,0,1-2-.4L245,399a2.37,2.37,0,0,0-1.93-.2l-4.92,2a.72.72,0,0,0-.51.63h0v.06h0v5h0a.82.82,0,0,0,.24.56l.29.3a2.54,2.54,0,0,1-1.36.42l-5.62-.23a1.54,1.54,0,0,0-1.43,1l-.85,2.72a1.34,1.34,0,0,0,0,.34h0v5.08h0a.92.92,0,0,0,.79.88l4.36.75-1.7.85a.72.72,0,0,0-.44.62h0v5.09h0a.74.74,0,0,0,.31.56l3.14,2.61a2.22,2.22,0,0,0,1.88.38l4.79-1.5a3.39,3.39,0,0,1,2,.13c.82.35,1.68.67,2.57.95a1.21,1.21,0,0,1,.63.44v3.43h0a1.06,1.06,0,0,0,1,1.05l6.16.65a1.71,1.71,0,0,0,1.58-.87l1.23-2.38a2.14,2.14,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.21,3.21,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.73.73,0,0,0,.51-.66h0V424h0a.84.84,0,0,0-.24-.55l-.29-.3a2.54,2.54,0,0,1,1.36-.42l5.62.23a1.51,1.51,0,0,0,1.42-1l.86-2.72a1.15,1.15,0,0,0,0-.31h0v-5.06h0a.91.91,0,0,0-.78-.94l-4.36-.75,1.7-.85a.7.7,0,0,0,.44-.63h0v-5.06h0a.76.76,0,0,0-.31-.59l-3.14-2.61a2.24,2.24,0,0,0-1.89-.38l-4.78,1.5a3.39,3.39,0,0,1-2-.13C267.4,403.09,266.54,402.77,265.65,402.49Zm-20.42,12.75a9.11,9.11,0,0,1,4.2-3c5.34-2.14,12.67-1.37,16.37,1.71a7.59,7.59,0,0,1,1.25,1.32,9.12,9.12,0,0,1-4.21,3.06c-5.34,2.14-12.67,1.37-16.37-1.71A7,7,0,0,1,245.23,415.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,414.67a1.82,1.82,0,0,0-1.3-1.25l-5.36-.92a.91.91,0,0,1-.79-.83v5a.92.92,0,0,0,.79.88l4.36.75,2.25-1.13a1.06,1.06,0,0,0,.45-1.45A9.29,9.29,0,0,1,236.33,414.67Zm1.31-8.17h0a.83.83,0,0,0,.24.56l.29.3a2.14,2.14,0,0,0,.46-.35,11.3,11.3,0,0,1,1.35-1.2,1,1,0,0,0,.14-1.45L237.89,402a.79.79,0,0,1-.24-.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43,407.13c-4.6,1.85-6.22,5.25-4.19,8.12a9,9,0,0,1,4.19-3.05c5.34-2.14,12.66-1.38,16.37,1.71a7.15,7.15,0,0,1,1.24,1.32c1.43-2,1.1-4.44-1.24-6.39C262.1,405.76,254.77,405,249.43,407.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,424.66a1.66,1.66,0,0,0-.51.59L256,427.64a1.7,1.7,0,0,1-.9.76v5.07a1.71,1.71,0,0,0,.9-.76l1.23-2.39a2,2,0,0,1,.53-.59Zm16.93-.68h0a.71.71,0,0,1-.51.66l-4.92,2a2.16,2.16,0,0,1-1.29.05v5.07a2.24,2.24,0,0,0,1.29-.05l4.93-2a.71.71,0,0,0,.5-.65ZM242,421.86l-4.72,1.49a2.19,2.19,0,0,1-1.19,0v5.05a2.14,2.14,0,0,0,1.2,0l4.73-1.49Zm41.45-8a1.57,1.57,0,0,1,0,.3l-.85,2.72a1.51,1.51,0,0,1-1.42,1l-5.63-.23a2.23,2.23,0,0,0-.88.18v5.07a2.23,2.23,0,0,1,.88-.18l5.62.23a1.53,1.53,0,0,0,1.43-1l.84-2.72a.87.87,0,0,0,.05-.31Zm-3-8.21a.58.58,0,0,1,0,.18.51.51,0,0,1-.17.26,1,1,0,0,1-.25.17l-3.95,2a.58.58,0,0,0-.23.17.87.87,0,0,0-.27.41,1,1,0,0,0-.06.39,1.49,1.49,0,0,0,0,.21l.09.27a7.24,7.24,0,0,1,.41,1.06,1.85,1.85,0,0,0,1.31,1.26l1,.16,1.71-.85a.73.73,0,0,0,.44-.62h0Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,424.66a1.66,1.66,0,0,0-.51.59L256,427.64a1.7,1.7,0,0,1-.9.76v5.07a1.71,1.71,0,0,0,.9-.76l1.23-2.39a2,2,0,0,1,.53-.59Zm16.93-.68h0a.71.71,0,0,1-.51.66l-4.92,2a2.16,2.16,0,0,1-1.29.05v5.07a2.24,2.24,0,0,0,1.29-.05l4.93-2a.71.71,0,0,0,.5-.65ZM242,421.86l-4.72,1.49a2.19,2.19,0,0,1-1.19,0v5.05a2.14,2.14,0,0,0,1.2,0l4.73-1.49Zm41.45-8a1.57,1.57,0,0,1,0,.3l-.85,2.72a1.51,1.51,0,0,1-1.42,1l-5.63-.23a2.23,2.23,0,0,0-.88.18v5.07a2.23,2.23,0,0,1,.88-.18l5.62.23a1.53,1.53,0,0,0,1.43-1l.84-2.72a.87.87,0,0,0,.05-.31Zm-3-8.21a.58.58,0,0,1,0,.18.51.51,0,0,1-.17.26,1,1,0,0,1-.25.17l-3.95,2a.58.58,0,0,0-.23.17.87.87,0,0,0-.27.41,1,1,0,0,0-.06.39,1.49,1.49,0,0,0,0,.21l.09.27a7.24,7.24,0,0,1,.41,1.06,1.85,1.85,0,0,0,1.31,1.26l1,.16,1.71-.85a.73.73,0,0,0,.44-.62h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,402.07l-4.78,1.5a3.39,3.39,0,0,1-2-.13c-.82-.35-1.68-.67-2.57-.95a1.33,1.33,0,0,1-.92-1.39l.28-2.33a1.06,1.06,0,0,0-.95-1.2l-6.16-.65a1.72,1.72,0,0,0-1.58.86l-1.23,2.39a2.14,2.14,0,0,1-1.59,1,30.54,30.54,0,0,0-3.19.4,3.21,3.21,0,0,1-2-.4L245,399a2.37,2.37,0,0,0-1.93-.2l-4.92,2a.7.7,0,0,0-.27,1.21l2.24,2.37a1,1,0,0,1-.14,1.44,13.3,13.3,0,0,0-1.35,1.21,2.76,2.76,0,0,1-1.82.77l-5.62-.23a1.54,1.54,0,0,0-1.43,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.36.92a1.82,1.82,0,0,1,1.3,1.25,7.82,7.82,0,0,0,.41,1.07,1.08,1.08,0,0,1-.46,1.45l-3.95,2a.66.66,0,0,0-.13,1.19l3.14,2.62a2.27,2.27,0,0,0,1.89.37l4.78-1.5a3.39,3.39,0,0,1,2,.13,25.21,25.21,0,0,0,2.57.95,1.34,1.34,0,0,1,.92,1.39l-.28,2.33a1.06,1.06,0,0,0,1,1.2l6.16.65a1.73,1.73,0,0,0,1.59-.86l1.22-2.39a2.17,2.17,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.19,3.19,0,0,1,2,.4l3.31,2.2a2.3,2.3,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.27-1.21l-2.24-2.37a1,1,0,0,1,.14-1.44,13.37,13.37,0,0,0,1.35-1.2,2.74,2.74,0,0,1,1.82-.78l5.62.23a1.51,1.51,0,0,0,1.43-1l.85-2.72a.93.93,0,0,0-.75-1.23l-5.35-.92a1.82,1.82,0,0,1-1.31-1.25,8.51,8.51,0,0,0-.4-1.06,1.08,1.08,0,0,1,.45-1.46l3.95-2a.66.66,0,0,0,.13-1.19l-3.14-2.61A2.24,2.24,0,0,0,275,402.07Zm-9.24,6.77c3.7,3.08,2.38,7.31-3,9.45s-12.67,1.37-16.37-1.71-2.37-7.31,3-9.45S262.1,405.76,265.8,408.84Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,402.07l-4.78,1.5a3.39,3.39,0,0,1-2-.13c-.82-.35-1.68-.67-2.57-.95a1.33,1.33,0,0,1-.92-1.39l.28-2.33a1.06,1.06,0,0,0-.95-1.2l-6.16-.65a1.72,1.72,0,0,0-1.58.86l-1.23,2.39a2.14,2.14,0,0,1-1.59,1,30.54,30.54,0,0,0-3.19.4,3.21,3.21,0,0,1-2-.4L245,399a2.37,2.37,0,0,0-1.93-.2l-4.92,2a.7.7,0,0,0-.27,1.21l2.24,2.37a1,1,0,0,1-.14,1.44,13.3,13.3,0,0,0-1.35,1.21,2.76,2.76,0,0,1-1.82.77l-5.62-.23a1.54,1.54,0,0,0-1.43,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.36.92a1.82,1.82,0,0,1,1.3,1.25,7.82,7.82,0,0,0,.41,1.07,1.08,1.08,0,0,1-.46,1.45l-3.95,2a.66.66,0,0,0-.13,1.19l3.14,2.62a2.27,2.27,0,0,0,1.89.37l4.78-1.5a3.39,3.39,0,0,1,2,.13,25.21,25.21,0,0,0,2.57.95,1.34,1.34,0,0,1,.92,1.39l-.28,2.33a1.06,1.06,0,0,0,1,1.2l6.16.65a1.73,1.73,0,0,0,1.59-.86l1.22-2.39a2.17,2.17,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.19,3.19,0,0,1,2,.4l3.31,2.2a2.3,2.3,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.27-1.21l-2.24-2.37a1,1,0,0,1,.14-1.44,13.37,13.37,0,0,0,1.35-1.2,2.74,2.74,0,0,1,1.82-.78l5.62.23a1.51,1.51,0,0,0,1.43-1l.85-2.72a.93.93,0,0,0-.75-1.23l-5.35-.92a1.82,1.82,0,0,1-1.31-1.25,8.51,8.51,0,0,0-.4-1.06,1.08,1.08,0,0,1,.45-1.46l3.95-2a.66.66,0,0,0,.13-1.19l-3.14-2.61A2.24,2.24,0,0,0,275,402.07Zm-9.24,6.77c3.7,3.08,2.38,7.31-3,9.45s-12.67,1.37-16.37-1.71-2.37-7.31,3-9.45S262.1,405.76,265.8,408.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,428.93h-.18l-6.15-.65a1.51,1.51,0,0,1-1.34-1.68l.28-2.33a.92.92,0,0,0-.62-.93,26.65,26.65,0,0,1-2.61-1,2.9,2.9,0,0,0-1.74-.12l-4.79,1.5a2.72,2.72,0,0,1-2.29-.45l-3.14-2.62a1.18,1.18,0,0,1-.46-1,1.17,1.17,0,0,1,.68-.89l4-2a.64.64,0,0,0,.26-.88,7.08,7.08,0,0,1-.43-1.13,1.44,1.44,0,0,0-1-1l-5.35-.91a1.37,1.37,0,0,1-1.09-1.78l.85-2.73a1.91,1.91,0,0,1,1.85-1.3l5.63.23a2.22,2.22,0,0,0,1.49-.65,15.3,15.3,0,0,1,1.39-1.24.54.54,0,0,0,.24-.41.48.48,0,0,0-.15-.39l-2.23-2.38a1.17,1.17,0,0,1-.34-1.07,1.21,1.21,0,0,1,.76-.83l4.92-2a2.8,2.8,0,0,1,2.33.24l3.31,2.2a2.66,2.66,0,0,0,1.67.33c1.06-.18,2.14-.32,3.23-.4a1.76,1.76,0,0,0,1.25-.8l1.22-2.39a2.18,2.18,0,0,1,2-1.09l6.15.64a1.51,1.51,0,0,1,1.34,1.68l-.28,2.34a.9.9,0,0,0,.62.92,24.32,24.32,0,0,1,2.61,1,3,3,0,0,0,1.74.11l4.79-1.5a2.72,2.72,0,0,1,2.29.45l3.14,2.62a1.18,1.18,0,0,1,.46,1,1.17,1.17,0,0,1-.68.89l-3.95,2a.64.64,0,0,0-.25.88,8.62,8.62,0,0,1,.42,1.13,1.44,1.44,0,0,0,1,.95l5.35.91a1.37,1.37,0,0,1,1.09,1.79l-.85,2.72a1.92,1.92,0,0,1-1.85,1.3l-5.63-.23a2.49,2.49,0,0,0-1.49.65,15.3,15.3,0,0,1-1.39,1.24.54.54,0,0,0-.24.41.5.5,0,0,0,.15.39l2.23,2.38a1.17,1.17,0,0,1,.34,1.07,1.19,1.19,0,0,1-.76.83l-4.92,2a2.77,2.77,0,0,1-2.33-.24l-3.31-2.2a2.66,2.66,0,0,0-1.67-.33c-1.06.18-2.14.32-3.23.4a1.74,1.74,0,0,0-1.25.81l-1.22,2.38A2.15,2.15,0,0,1,254.5,428.93Zm-11.71-7.61a3.64,3.64,0,0,1,1.43.27c.8.34,1.65.65,2.53.93a1.78,1.78,0,0,1,1.22,1.85l-.29,2.34a.65.65,0,0,0,.14.48.67.67,0,0,0,.44.24l6.15.64a1.3,1.3,0,0,0,1.16-.63l1.23-2.39a2.59,2.59,0,0,1,1.94-1.27q1.61-.12,3.15-.39a3.59,3.59,0,0,1,2.3.46l3.31,2.2a1.9,1.9,0,0,0,1.53.16l4.92-2a.33.33,0,0,0,.24-.22.36.36,0,0,0-.12-.29l-2.24-2.38a1.34,1.34,0,0,1-.38-1.05,1.41,1.41,0,0,1,.57-1,13.39,13.39,0,0,0,1.3-1.16,3.14,3.14,0,0,1,2.15-.91l5.62.23a1,1,0,0,0,1-.7l.86-2.72a.55.55,0,0,0,0-.44.56.56,0,0,0-.38-.24l-5.35-.91a2.25,2.25,0,0,1-1.64-1.56,6.88,6.88,0,0,0-.39-1,1.51,1.51,0,0,1,.65-2l3.95-2c.13-.06.21-.14.21-.22a.36.36,0,0,0-.15-.26l-3.14-2.61a1.84,1.84,0,0,0-1.49-.3l-4.79,1.5a3.74,3.74,0,0,1-2.33-.14,24.24,24.24,0,0,0-2.52-.93,1.79,1.79,0,0,1-1.23-1.86l.29-2.33a.66.66,0,0,0-.14-.49A.62.62,0,0,0,264,398l-6.15-.65a1.3,1.3,0,0,0-1.16.63l-1.23,2.39a2.56,2.56,0,0,1-1.94,1.27q-1.6.12-3.15.39a3.53,3.53,0,0,1-2.3-.46l-3.31-2.2a1.9,1.9,0,0,0-1.53-.16l-4.92,2c-.13.06-.22.13-.24.22a.34.34,0,0,0,.13.29l2.23,2.38a1.35,1.35,0,0,1,.38,1.05,1.41,1.41,0,0,1-.57,1,12.26,12.26,0,0,0-1.3,1.17,3.17,3.17,0,0,1-2.15.9l-5.62-.23a1.08,1.08,0,0,0-1,.7l-.86,2.72a.55.55,0,0,0,0,.44.53.53,0,0,0,.38.24l5.35.91a2.27,2.27,0,0,1,1.65,1.56,5.27,5.27,0,0,0,.38,1,1.51,1.51,0,0,1-.65,2l-3.95,2c-.13.07-.21.15-.21.22a.36.36,0,0,0,.15.26l3.15,2.62a1.81,1.81,0,0,0,1.48.29l4.79-1.5A3.11,3.11,0,0,1,242.79,421.32Zm13.38-1.4c-3.84,0-7.62-1.05-10-3A5.26,5.26,0,0,1,244,412c.34-2.16,2.26-4.09,5.27-5.3,5.46-2.18,13-1.39,16.8,1.78h0a5.26,5.26,0,0,1,2.2,4.88c-.34,2.16-2.26,4.09-5.27,5.3A18.69,18.69,0,0,1,256.17,419.92Zm0-13.57a17.82,17.82,0,0,0-6.54,1.18c-2.72,1.09-4.45,2.78-4.74,4.64a4.41,4.41,0,0,0,1.9,4.08c3.59,3,10.73,3.72,15.93,1.64,2.72-1.09,4.45-2.78,4.74-4.63a4.43,4.43,0,0,0-1.9-4.09C263.31,407.33,259.76,406.35,256.13,406.35Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--image--inject-14",
    d: "M356.78,260.47l-29.25,16.89a4.43,4.43,0,0,0-1.85,3.53v32.47c0,1.36.83,2,1.85,1.4l29.25-16.89a4.43,4.43,0,0,0,1.85-3.53V261.87C358.63,260.51,357.8,259.88,356.78,260.47Zm-.56,26.26L349.43,280l-6,9.72,2.45,5.82-10.63-10.59-7.14,18V280.25L356.22,264Zm-12.57-6.11a4.78,4.78,0,0,0,2-3.81c0-1.47-.89-2.14-2-1.51a4.79,4.79,0,0,0-2,3.81C341.65,280.58,342.55,281.25,343.65,280.62Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,299a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l1.3-.75a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-1.3.75A.59.59,0,0,1,318.14,299Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,302.35a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.91-1.68a.5.5,0,1,1,.5.87l-2.91,1.68A.47.47,0,0,1,312.31,302.35Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,304.78a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l1.3-.75a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-1.3.75A.43.43,0,0,1,308.09,304.78Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--location--inject-14",
    d: "M342.05,212.31c-5.45,3.15-9.95,12-9.89,19.76v1.76c0,5.16,4.76,10.6,8.08,14,1.06,1.1,3,0,4.08-2.35,3.24-7.21,7.86-18,7.82-23.2v-1.76C352.08,212.81,347.51,209.16,342.05,212.31Zm.14,20.08c-2.9,1.68-5.38,0-5.4-3.87s2.41-8.38,5.3-10.05,5.38,0,5.4,3.87S345.08,230.72,342.19,232.39Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,242.7a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l1.3-.75a.5.5,0,0,1,.5.86l-1.3.75A.47.47,0,0,1,318.14,242.7Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,246.06a.5.5,0,0,1-.25-.93l2.91-1.68a.5.5,0,1,1,.5.86L312.56,246A.47.47,0,0,1,312.31,246.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,248.49a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l1.3-.75a.5.5,0,1,1,.5.87l-1.3.74A.43.43,0,0,1,308.09,248.49Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Awards--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--awards--inject-14",
    d: "M342.15,155.28c-3.61,2.09-6.53,7.68-6.53,12.49s2.92,7,6.53,4.94,6.54-7.68,6.54-12.49S345.76,153.2,342.15,155.28Zm2.79,24.59-2.79-1-2.79,4.26-1.73-2.93-2,24.3,6.53-11.87,6.54,4.33-2-22Zm8.77-20.93-2-1.83,1.47-4.29-2.7-.08.28-4.09-3,1.67-.94-3.21-2.73,3.15-2-1.76-2,4.07h-2.71l-.94,4.29-3,1.76.28,3.77-2.7,3.2,1.46,2.59-2,4.11,2.39,1-.89,4.29,2.89-.81.34,3.72,2.91-2.46,1.5,2.54,2.42-3.69,2.42.9,1.51-4.28,2.91-.9.33-4.12,2.9-2.52-.89-3.26Zm-11.56,16.4c-4.7,2.71-8.51-.17-8.51-6.43s3.81-13.55,8.51-16.26,8.52.16,8.52,6.43S346.86,172.62,342.15,175.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,186.41a.5.5,0,0,1-.25-.93l1.3-.75a.5.5,0,0,1,.5.87l-1.3.75A.57.57,0,0,1,318.14,186.41Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,189.78a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l2.91-1.68a.5.5,0,1,1,.5.87l-2.91,1.68A.59.59,0,0,1,312.31,189.78Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,192.21a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l1.3-.75a.51.51,0,0,1,.69.19.5.5,0,0,1-.19.68l-1.3.75A.52.52,0,0,1,308.09,192.21Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Study--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--study--inject-14",
    d: "M340.22,109.72a3.83,3.83,0,0,1,.2-2.15,4.46,4.46,0,0,1,1.73-2.35,1.5,1.5,0,0,1,1-.22l10.8,2.08,7.79-10.49-19.6-3.77-19.59,26.4L342.15,123l7.79-10.49-8.79-1.7A1.23,1.23,0,0,1,340.22,109.72ZM328.3,122.83v8.64c0,2.72,1.35,4.67,4.06,5.19,4.61.89,11.66-2.66,17-8.23l.54-4.42a2.75,2.75,0,0,1-.66-2,6.75,6.75,0,0,1,.71-2.87V115l-7.79,10.48Zm25.66-6a2.64,2.64,0,0,1,.72,2,6.64,6.64,0,0,1-.66,2.75l.06.4a14.56,14.56,0,0,0,1.93-6.55v-8.64L354,109.59Zm-.49,2.74c0-.72-.28-1.19-.71-1.3V108.7l-10.2-2c-.39-.07-.88.39-1.1,1s-.09,1.22.29,1.29l9.4,1.81v8.33a3.86,3.86,0,0,0-.72,2.13c0,.75.31,1.22.76,1.31l-.73,6c0,1.42,3-.3,3-1.72l-.73-5.14A3.82,3.82,0,0,0,353.47,119.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,130.13a.51.51,0,0,1-.44-.25.52.52,0,0,1,.19-.69l1.3-.74a.5.5,0,1,1,.5.86l-1.3.75A.47.47,0,0,1,318.14,130.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,133.49a.5.5,0,0,1-.25-.93l2.91-1.68a.5.5,0,1,1,.5.86l-2.91,1.68A.47.47,0,0,1,312.31,133.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,135.92a.5.5,0,0,1-.25-.93l1.3-.75a.51.51,0,0,1,.69.18.49.49,0,0,1-.19.68l-1.3.75A.43.43,0,0,1,308.09,135.92Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Contact--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--contact--inject-14",
    d: "M342.15,64.72c3.43-2,6.21-7.29,6.21-11.86s-2.78-6.67-6.21-4.69S336,55.46,336,60,338.73,66.7,342.15,64.72Zm10.44,2.74c-.42-3-2.55-4.2-5-2.76l-10.78,6.22c-2.49,1.44-4.63,5.07-5.05,8.59L331,85.79c-.07.59.24.91.66.67l21-12.15a1.61,1.61,0,0,0,.67-1.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.14,73.84a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l1.3-.75a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-1.3.75A.57.57,0,0,1,318.14,73.84Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,77.2a.5.5,0,0,1-.25-.93L315,74.59a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-2.91,1.68A.57.57,0,0,1,312.31,77.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,79.63a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l1.3-.75a.5.5,0,1,1,.5.87l-1.3.75A.51.51,0,0,1,308.09,79.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.34,323.65V450.88a1.61,1.61,0,0,0,.89,1.46,3.38,3.38,0,0,0,1.68.42,3.42,3.42,0,0,0,1.69-.42,1.62,1.62,0,0,0,.89-1.46V323.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.92,421.85c-10.06,0-20.11-2.21-27.76-6.63s-11.79-10.29-11.79-16.61,4.18-12.21,11.79-16.6c15.3-8.84,40.21-8.84,55.52,0,7.6,4.39,11.79,10.29,11.79,16.6s-4.19,12.22-11.79,16.61h0C426,419.64,416,421.85,405.92,421.85Zm0-44.5c-9.7,0-19.39,2.13-26.77,6.39-6.95,4-10.79,9.3-10.79,14.87s3.84,10.86,10.79,14.88c14.76,8.52,38.77,8.52,53.53,0h0c7-4,10.79-9.3,10.79-14.88s-3.83-10.85-10.79-14.87C425.3,379.48,415.61,377.35,405.92,377.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5,435.79,432.71,316.06l-8.1-.57h2.83L441.37,436a1.72,1.72,0,0,0,.88,1.33,3.41,3.41,0,0,0,1.69.41,3.37,3.37,0,0,0,1.68-.41A1.56,1.56,0,0,0,446.5,435.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,435.79l13.8-119.73,8.1-.57h-2.84L370.8,436a1.72,1.72,0,0,1-.88,1.33,3.67,3.67,0,0,1-3.37,0A1.56,1.56,0,0,1,365.67,435.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,290.27c13.6-7.85,35.63-7.85,49.23,0,6.79,3.93,10.18,9.07,10.18,14.21v6.32c0,5.14-3.39,10.28-10.19,14.2-13.59,7.85-35.62,7.85-49.22,0-6.79-3.93-10.18-9.07-10.18-14.21v-6.32C370.75,299.34,374.14,294.2,380.93,290.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,287.2c13.6-7.84,35.63-7.84,49.23,0,6.79,3.93,10.18,9.07,10.18,14.21v6.32c0,5.14-3.39,10.28-10.19,14.21-13.59,7.84-35.62,7.84-49.22,0-6.79-3.93-10.18-9.07-10.18-14.21v-6.32C370.75,296.27,374.14,291.13,380.93,287.2Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,287.2c13.6-7.84,35.63-7.84,49.23,0,6.79,3.93,10.18,9.07,10.18,14.21v6.32c0,5.14-3.39,10.28-10.19,14.21-13.59,7.84-35.62,7.84-49.22,0-6.79-3.93-10.18-9.07-10.18-14.21v-6.32C370.75,296.27,374.14,291.13,380.93,287.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.54,
    cy: 301.41,
    rx: 34.8,
    ry: 20.09,
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.54,
    cy: 301.41,
    rx: 34.8,
    ry: 20.09,
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.93,189.21c-10-1.28-14.89,1.14-26.86,13.67-7.47,7.83-16.46,16.91-16.46,16.91s-7.48-8.56-11.16-14.06c-4.32-6.44-5.88-8-5.24-12.29a109.67,109.67,0,0,0,3-14.95,35.5,35.5,0,0,0-7.62,4.61,2.19,2.19,0,0,0-1,1.39c-.05.41.12.83.09,1.24a2.55,2.55,0,0,1-.84,1.5c-.86.87-1.9,1.76-2,3-.05.68.2,1.1.19,1.78,0,1.14-.74,1.36-1.21,2.34-.58,1.24-.55,2.35.07,4.5.71,2.42,1.43,8,2.19,10.5,2.21,7.32,2.87,9.39,4.52,14a45.46,45.46,0,0,0,10.3,16.79c4.28,4.31,8.24,3,16.9-2.91,11.51-7.82,28.22-23.52,28.22-23.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.52,191.93A12.24,12.24,0,0,0,341,195a4.21,4.21,0,0,1,1.33,3.47c-.06,2.42-1.31,3.8-.16,5.67a3.64,3.64,0,0,1,.67-3.83C344.63,198.06,344.26,193.09,343.52,191.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.28,120.18l-2.78-16.26a2.69,2.69,0,0,0-4.93-1l-8.72,14a52,52,0,0,0-7,17.56l-46.4,235.07h0a12.09,12.09,0,0,0,23.72,4.68h0s36.72-185.46,46.41-235.13C379.84,132.91,379.34,126.42,378.28,120.18Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,120.18l-2.78-16.26a2.69,2.69,0,0,0-4.93-1l-8.72,14a52,52,0,0,0-7,17.56l-46.4,235.07h0a12.09,12.09,0,0,0,23.72,4.68h0s36.72-185.46,46.41-235.13C379.84,132.91,379.34,126.42,378.28,120.18Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.78,105.52l-.28-1.6a2.69,2.69,0,0,0-4.93-1l-.85,1.37a1.77,1.77,0,0,0,.66,1.09,4.93,4.93,0,0,0,4.38.87A1.85,1.85,0,0,0,375.78,105.52Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.61,358.86c-5.16,1.76-12.65.28-16.75-3.3-2.05-1.79-2.86-3.77-2.52-5.52l1.06-5.37c-.35,1.75.47,3.73,2.52,5.52,4.09,3.58,11.59,5.06,16.75,3.3,2.57-.88,4.07-2.4,4.42-4.15L336,354.71C335.69,356.46,334.18,358,331.61,358.86Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,147.64c-5.16,1.76-12.67.28-16.78-3.31-2.05-1.79-2.87-3.77-2.52-5.53l1.06-5.37c-.34,1.75.47,3.73,2.52,5.52,4.11,3.59,11.62,5.08,16.78,3.31,2.58-.88,4.08-2.4,4.43-4.15l-1.06,5.37C377.42,145.24,375.92,146.76,373.34,147.64Z",
    style: {
      fill: "#0165E1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.19,178.49c1.19-.39,3.82,0,5.92.5s3.73,0,3.63,1.42c0,.7-.8,1.48-1.87,1.87a10.15,10.15,0,0,1-2.95.51c2.65,1,3.34,1.51,3,2.34-.49,1.18-2,1.63-3.47,1.49.94.44,1.85.51,1.74,1.31s-1.26,1.46-2.81,1.74a9.45,9.45,0,0,1-3,.06c-1.38,1-2.87,2.2-2.87,2.2A39.61,39.61,0,0,1,346.19,178.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.44,186.62c-1-.16-2-.45-3-.64a3.93,3.93,0,0,0-2.8.71c-.91.47-1.79,1-2.66,1.53s-1.77,1-2.68,1.51c.82-.61,1.67-1.18,2.53-1.76s1.73-1.11,2.63-1.61a9.8,9.8,0,0,1,1.44-.63,2.9,2.9,0,0,1,1.6,0C348.5,186,349.45,186.31,350.44,186.62Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92,182.79c-.91-.19-1.82-.39-2.73-.54a13.08,13.08,0,0,0-1.34-.19,3.56,3.56,0,0,0-1.27.35c-.84.34-1.65.79-2.48,1.22s-1.64.86-2.48,1.26c.76-.54,1.55-1,2.34-1.51a23.44,23.44,0,0,1,2.48-1.32,4.11,4.11,0,0,1,1.41-.34,10.21,10.21,0,0,1,1.4.25A19.14,19.14,0,0,1,350.92,182.79Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.94,323.28s22.67,30.66,26.61,37.06c2.92,4.76,5.19,8.27,6.35,12.23s1.24,10.39,1,13.66c0,0-1,8.85.45,8.58s12.55-6.77,16.13-11.55,1.18-9-2.51-17.31-10-19.67-10-19.67a5.74,5.74,0,0,1-1.36-.86c-2.13-1.6-12.72-27.16-15-33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,352.73c1.05,1.82,1.23,4.75,2.71,7.71a58,58,0,0,0,6,9.59c2.81,3.66,3.2,4.19,3.2,4.19l-1.13.86-5.84-7.62c-1.77-2.33-3.61-3.7-4.92-3.1C389.16,364.36,383.63,356.94,389.13,352.73Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.13,352.73c1.05,1.82,1.23,4.75,2.71,7.71a58,58,0,0,0,6,9.59c2.81,3.66,3.2,4.19,3.2,4.19l-1.13.86-5.84-7.62c-1.77-2.33-3.61-3.7-4.92-3.1C389.16,364.36,383.63,356.94,389.13,352.73Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,345.46c2.19,1.41,5.54,2,8.68,4.25a7.87,7.87,0,0,1,2.76,3.9c-.19,1.63-.53,2.41-.72,3.57a11.94,11.94,0,0,0,0,5.73,86,86,0,0,0,4.11,11.32c1.56,3.64,2.66,5.73,1.13,9.24-1.19,2.74-6.59,8.83-10.71,12.3-5.62,4.73-10.33,3.53-9.8-.37s1.1-8.19,1.42-9.17a13.39,13.39,0,0,1,6.05-3.29c4.35-1,6.82.13,9-4.16,2-3.89-.49-11.34-6.93-19.5C375.75,350,378.07,345.46,378.07,345.46Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,345.46c2.19,1.41,5.54,2,8.68,4.25a7.87,7.87,0,0,1,2.76,3.9c-.19,1.63-.53,2.41-.72,3.57a11.94,11.94,0,0,0,0,5.73,86,86,0,0,0,4.11,11.32c1.56,3.64,2.66,5.73,1.13,9.24-1.19,2.74-6.59,8.83-10.71,12.3-5.62,4.73-10.33,3.53-9.8-.37s1.1-8.19,1.42-9.17a13.39,13.39,0,0,1,6.05-3.29c4.35-1,6.82.13,9-4.16,2-3.89-.49-11.34-6.93-19.5C375.75,350,378.07,345.46,378.07,345.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.45,252.68c-.94,6.11-7,9.53-17.45,15.8s-31.37,21.51-35.83,28.4c-4,6.12-2.54,11.9,2.64,22s28.56,44.42,28.56,44.42L379.31,348s-6.51-22.95-9.89-29.13c-2.65-4.84-4.83-6.24-4.83-6.24l37.67-19.08,6.84-21.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.37,363.27,379.31,348s-6.51-22.95-9.89-29.13a27.4,27.4,0,0,0-3.05-4.54c-3.09,4.46-4.9,6.94-6.18,17.73-.58,4.88-1.17,12.61-1.63,19.61C363,358.34,366.37,363.27,366.37,363.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.78,269.07c0,8.81.67,15.46.67,15.46l-20.36,26.32,34.17-17.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,282.29a104.3,104.3,0,0,0-13.21,10.48,42.32,42.32,0,0,0-5.47,6.23,15.78,15.78,0,0,0-1.88,3.52,5.6,5.6,0,0,0-.34,1.79,12.09,12.09,0,0,0,.24,1.94,43,43,0,0,0,2.65,7.83c1.08,2.58,2.29,5.12,3.52,7.65q3.75,7.56,7.75,15a147.66,147.66,0,0,1-9-14.4q-2.06-3.74-3.82-7.63a41.26,41.26,0,0,1-2.82-8.17,13.84,13.84,0,0,1-.24-2.27,7.16,7.16,0,0,1,.45-2.35,15.55,15.55,0,0,1,2.16-3.9,38.26,38.26,0,0,1,5.9-6.28A72.88,72.88,0,0,1,361.45,282.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,365.28c-2.56,21.17-4.25,34.73-5.69,40.12s-3.07,10.72-5,14.39a37.13,37.13,0,0,1-7.55,9.45s-6.86,5.69-5.59,6.52,13.76,3.76,19.64,2.76,7.09-5.73,10.12-14.27,6.3-21.16,6.3-21.16a5.86,5.86,0,0,1-.4-1.56c-.43-2.63,3.88-12.29,6.23-18.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.36,414.78c-.49,2-2.39,4.28-3.35,7.45a57,57,0,0,0-2.26,11.08c-.5,4.59-.57,5.25-.57,5.25l-1.42-.16s.72-6.63,1-9.55-.07-5.17-1.43-5.63C367.36,423.22,368.47,414,375.36,414.78Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.36,414.78c-.49,2-2.39,4.28-3.35,7.45a57,57,0,0,0-2.26,11.08c-.5,4.59-.57,5.25-.57,5.25l-1.42-.16s.72-6.63,1-9.55-.07-5.17-1.43-5.63C367.36,423.22,368.47,414,375.36,414.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,401.88c.62,2.53,2.66,5.24,3.35,9.06a7.86,7.86,0,0,1-.68,4.73c-1.26,1.05-2,1.38-3,2.09a11.81,11.81,0,0,0-4,4.14,86.51,86.51,0,0,0-4.83,11c-1.38,3.72-2,6-5.55,7.49-2.75,1.16-10.87,1.84-16.24,1.52-7.33-.45-9.91-4.57-6.84-7s6.44-5.17,7.35-5.66a13.31,13.31,0,0,1,6.65,1.79c3.85,2.26,4.85,4.79,9.4,3.2,4.12-1.45,7.46-8.55,8.43-18.9C367.54,403.58,372.36,401.88,372.36,401.88Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.24,254.7c1.17,5.71,5,12.6,5.16,20.3.16,5.83.07,15.11-11.46,25.88s-40.16,30.58-41.35,33.47S388.53,360,386,366.68c-4.74,12.42-11.92,28-11.92,28-7.54,2.09-13.64,1.49-18.22-2,0,0,3.57-30.44,5-43.28,2.37-22,2.54-28.82,6.56-34.42s5.44-7.37,5.44-7.37l18.82-22.53s-2.33-5.59-3.84-16c-1-7,.67-16.39.67-16.39S415.22,262.45,438.24,254.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,281.82l.14-.4c4-6.68,2.6-12.9.75-21-.31-1.37-.63-2.8-.94-4.28l-.87.19c.32,1.48.63,2.91.95,4.29,1.77,7.78,3.11,13.76-.48,20.06-6.12-2.95-5.21-12.79-4.63-18.78.09-1,.18-1.88.22-2.62l-.88-.05c0,.73-.13,1.61-.22,2.58-.6,6.21-1.57,16.43,5,19.66a24.76,24.76,0,0,1-2.31,3.05c-4.65,5.25-16.43,16.39-26.83,26.22-8.21,7.77-15.31,14.48-16.86,16.39-2,2.4-2.87,9.5-4,18.48a198.57,198.57,0,0,1-3.9,23.14,120,120,0,0,1-11,27.13l1.06-.09a120.94,120.94,0,0,0,10.78-26.82,201.55,201.55,0,0,0,3.92-23.25c1.09-8.49,2-15.82,3.84-18,1.51-1.86,8.59-8.55,16.78-16.29,10.41-9.85,22.21-21,26.88-26.28a24.45,24.45,0,0,0,2.48-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,262.18a29.67,29.67,0,0,1-.09,8.52,41.69,41.69,0,0,1-2.08,8.3,45.1,45.1,0,0,1-3.65,7.73,37.82,37.82,0,0,1-5.1,6.81c1.36-2.49,2.68-5,3.88-7.46s2.28-5.07,3.21-7.68a72.9,72.9,0,0,0,2.39-8A69.83,69.83,0,0,0,417.94,262.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.9,262.18a28,28,0,0,1,1.94,7,46,46,0,0,1,.52,7.23,49.58,49.58,0,0,1-.58,7.2,28.17,28.17,0,0,1-1.88,7c.25-2.4.39-4.75.5-7.12s.2-4.72.19-7.08,0-4.71-.12-7.07S420.17,264.57,419.9,262.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.27,303.07c-2.8,4-5.75,7.84-8.53,11.79-1.37,2-2.71,4-3.87,6.06a24.52,24.52,0,0,0-2.63,6.49c-.46,2.31-.9,4.73-1.32,7.1l-1.28,7.16c-.85,4.77-1.8,9.54-2.81,14.3q.45-7.29,1.39-14.52c.63-4.83,1.32-9.6,2.32-14.43a24.21,24.21,0,0,1,2.92-6.91,55.71,55.71,0,0,1,4.22-6C378.69,310.22,382,306.63,385.27,303.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,389.65c2.87,2.82,14.5,4.54,19.05,2.42l-2.45,6.25s-1.37,1.89-8.93,1.22-8.44-3.65-8.44-3.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389,246.64a3.47,3.47,0,0,1-1.09-3c.51-4.74.24-6.06-.14-11.39-7.88-9-4.92-16.32-3.45-20.4,3.62-10,18.58-22.61,18.58-22.61l4.92.33c9.73.38,16.95,1.15,21.67,1.77s8.72,1.32,8.72,1.32c-3.06,6.86-3.17,16.18-1.42,21.1,2.84,8,6.61,11.73,6.61,11.73s-4.84,15.08-4.85,20.74a3.58,3.58,0,0,1-1.4,2.81c-.51,2-.69,3.67-1.19,5.71C408.28,261.6,393.22,254.27,389,246.64Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.18,249c-4.21,2.42-11.5,5.26-23,5.26s-21.72-4.34-25.12-7.63l-.58,6s7.59,7.55,25.5,7.86,24.29-5.84,24.29-5.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.26,232.38s4.49,5.61,14.15,4,11.55-8.9,11.55-8.9.58,9.37-11,11.26C405.63,240.59,402.26,232.38,402.26,232.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,153.37c-.12.68-.84,1.13-1.48,1.72a5.44,5.44,0,0,0-1.62,4.65c.08,1.69,1.36,2.76,3,3.48s3.46,1,3.61,2.72c.11,1.18-.4,2.46-.41,3.67,0,2,1.25,3.34,3.26,4.06,1.59.56,3,.78,4.2,1.93.91.86.74,2.26,1.59,3.19s2.11,2,3.67,1.75a11.51,11.51,0,0,1,2-.42,5.62,5.62,0,0,1,2.72.57c1.6.84,2.74,2.11,4.87,2,1.55-.1,2.83-1.16,4.43-1.08,1.39.06,2.46.79,3.89.84a43.26,43.26,0,0,0,4.82-.27c1.82-.14,1.82-.85,2.57-2.07s1.44-2.17,2.18-3.24a72.73,72.73,0,0,1,5.79-7.55c5.7-6.27,8-16.69.64-21.68,0,0-.1-8.72-7.77-12.39a25.78,25.78,0,0,0-4.84-1.75,23.53,23.53,0,0,0-4.07-.68,89.64,89.64,0,0,1-10.68-1.91c-3.29-.64-7-1.14-10.29.68a9.09,9.09,0,0,0-3.33,2.57c-1,1.49-.95,3.23-1.86,4.75-1.08,1.79-2.86,2.07-4.62,3.11-1.56.92-3.32,2.27-3.89,3.84a6.48,6.48,0,0,0-.39,3.27c.25,1.42,1.64,2.37,2,3.71A1.21,1.21,0,0,1,385.1,153.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.51,145s-5.93,7-5.57,22.38c.18,7.78,1.58,13.2,6.4,15.31a20.37,20.37,0,0,0,8.93,1.1l-.06,6.58,17.25.61,1-15.89s2.76,2.54,6.25-.66c3.83-3.53,4.07-9.2,1.31-11.25-4-3-7.19.26-8.3,2.29s-4.11,1.56-3.16-3.18.77-13.21-3.18-14.7C414.49,145.72,407.38,156.52,398.51,145Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,171.6l-5.95,1.31a2.8,2.8,0,0,0,3.39,2.45A3.43,3.43,0,0,0,410.11,171.6Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,156.48l3.95,2.1a2.18,2.18,0,0,0-.75-3.1A2.46,2.46,0,0,0,412,156.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.77,161.73A1.75,1.75,0,1,1,412,160,1.75,1.75,0,0,1,413.77,161.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.09,160.64a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,401.09,160.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,155.41l-4.16,2.14a2.35,2.35,0,0,1,1.06-3.11A2.28,2.28,0,0,1,400.44,155.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.31 158.42 404.88 168.89 399.11 166.78 406.31 158.42",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,183.77c2.66-.31,9-2,12.33-4.06a13,13,0,0,0,3.95-4.86s-.79,4.72-3.5,6.75c-4.29,3.21-12.81,5.05-12.81,5.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.88,173.3a4,4,0,0,0-.7,0,4.47,4.47,0,0,0-3.35,1.93,2.85,2.85,0,0,0,1.72.16A3.33,3.33,0,0,0,409.88,173.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,182.8l-.11,1.87a16.92,16.92,0,0,1-9.66,3.18c-6.09.22-8-1.2-8-1.2l0-1.8a2.25,2.25,0,0,0-1.93,1.1c-.69,1.17-3.15,5.83-3.41,8.08s3.45,6.26,11.67,5.69c10.67-.74,14.08-5.88,14.74-7.37s-.74-4.78-1.33-7S427.27,182.69,426,182.8Z",
    style: {
      fill: "#0165E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,182.8l-.11,1.87a16.92,16.92,0,0,1-9.66,3.18c-6.09.22-8-1.2-8-1.2l0-1.8a2.25,2.25,0,0,0-1.93,1.1c-.69,1.17-3.15,5.83-3.41,8.08s3.45,6.26,11.67,5.69c10.67-.74,14.08-5.88,14.74-7.37s-.74-4.78-1.33-7S427.27,182.69,426,182.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.24,192.63c7.6,1.05,10,.9,18.42,14.18s16.08,26.45,19.09,33.15c1.67,3.7,3.06,6.94-.53,10.79-3.13,3.35-13.74,11.93-21,17.4,0,0-13.23-6.7-11.5-8.91,3.83-4.93,9.25-11.66,13.1-16l-14.26-18.9s-5.67-7.17-7-14.45C433.27,203.08,433.85,197,438.24,192.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.79,243.21c2.5,2.5,8.49,2.4,8.49,2.4a10,10,0,0,1-9.55-1.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.42,274.47c-.49-.8-.93-2.43-2.09-2.34-1.39.1-2.52,1.54-3,2.7-1.14,2.6-.55,7.91,3.42,6.18,1.28-.56,2.58-1.3,2.68-2.78C456.46,277.11,455.94,276.08,455.42,274.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.22,268.62c1-4.54,1.88-4.85,5.47-9.38.91-1.16,3.49-4.28,3.49-4.28,4.35-2.28,11.43,7.43,9.57,11.93a24,24,0,0,0-3.46,3c-.76,1.52-.63,4.75-.63,7.18a7.52,7.52,0,0,1-1,3.48l3.25-1.27s-2-3.55.36-5.45c1-.57,1.8.71,3,3.44a11.59,11.59,0,0,1,.34,5.75c-.33,1.17-6.1,5.27-9.2,4.73s-10.48-5.53-12-7.59S436.69,271,437.22,268.62Z",
    style: {
      fill: "#ffa8a7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.78,117.57l3.6-6.78-2.9-8.36V97.3l8.87,5.13v5.12l-3.81,6.61a.63.63,0,0,1-.26.23h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,55.42a5.86,5.86,0,0,1,2.66-4.6l1-.56a5.87,5.87,0,0,1,5.32,0l31.87,18.37a5.88,5.88,0,0,1,2.66,4.61V112.3a5.88,5.88,0,0,1-2.66,4.61l-1,.55a5.87,5.87,0,0,1-5.32,0l-11.62-6.69-3.8,6.6a.57.57,0,0,1-1-.1l-4-11.61-11.39-6.57a5.88,5.88,0,0,1-2.66-4.61Z",
    style: {
      fill: "#455a64"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.34,112.3a5.88,5.88,0,0,1-2.66,4.61l-1,.55a5.92,5.92,0,0,1-4.86.21c1.25.48,2.2-.23,2.2-1.75V77.6c0-1.56.06-2.71-.42-3.54l5.92-3.44a5.43,5.43,0,0,1,.78,2.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396,54.67c.32-1.13,1.35-1.49,2.57-.78L430.4,72.26a5.52,5.52,0,0,1,2.23,1.8l5.92-3.44a5.34,5.34,0,0,0-1.87-2L404.81,50.26a5.93,5.93,0,0,0-5.32,0l-1,.56A5.91,5.91,0,0,0,396,54.67Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--World--inject-14",
    d: "M423.77,79.12l-.17-.31,0,0c-2.35-4.48-5.47-8-8.79-9.92s-6.22-2-8.54-.43l-.19.13-.1.08c-2.36,1.78-3.66,5.21-3.66,9.65A30.66,30.66,0,0,0,406,92.15c2.36,4.51,5.49,8,8.83,10s6.46,2,8.82.23,3.66-5.22,3.66-9.66A30.71,30.71,0,0,0,423.77,79.12Zm-5-2.18c.28.9.53,1.85.74,2.83a7.89,7.89,0,0,1-2.5-.46l-.24-.08a12.36,12.36,0,0,1-1.53-.72V70.87l.1.06c.28.18.56.38.83.58A16.75,16.75,0,0,1,418.73,76.94Zm-.9-4a24.88,24.88,0,0,1,4.57,6.1,5.77,5.77,0,0,1-1.76.62l-.22,0-.32,0c-.23-1.06-.49-2.09-.8-3.06A24,24,0,0,0,417.83,73Zm-3.49,11.72-5.2-3A29.84,29.84,0,0,1,409.9,75a22.77,22.77,0,0,0,2.56,2.62l.26.21a16,16,0,0,0,1.62,1.19Zm0,1.15v5.58a11.08,11.08,0,0,0-1.62-.69l-.26-.08a8,8,0,0,0-2.56-.33,43.8,43.8,0,0,1-.76-7.48Zm.86.5,5.21,3a29.74,29.74,0,0,1-.7,6.37,22.14,22.14,0,0,0-2.62-2.53l-.26-.2a16.77,16.77,0,0,0-1.63-1.11Zm0-1.15v-5.6a13.35,13.35,0,0,0,1.63.78l.26.09a8.41,8.41,0,0,0,2.62.5,43.12,43.12,0,0,1,.7,7.24Zm-.95-14.85.09,0V78a16.13,16.13,0,0,1-1.49-1.09l-.24-.21a20.52,20.52,0,0,1-2.46-2.54,13.22,13.22,0,0,1,.67-1.76c.74-1.52,1.63-2.33,2.6-2.42A7.64,7.64,0,0,1,414.25,70.33Zm-4,1.12a13.32,13.32,0,0,0-.72,1.89c-.1-.13-.2-.25-.29-.38l-.22-.29a30.21,30.21,0,0,1-1.62-2.57,5.9,5.9,0,0,1,4.32-.67A6,6,0,0,0,410.25,71.45Zm-1.62,1.94.22.31c.14.19.29.36.43.55a30.67,30.67,0,0,0-.82,7l-4.82-2.78c.1-3.65,1.22-6.47,3.17-8A32.82,32.82,0,0,0,408.63,73.39Zm-.17,9a45.07,45.07,0,0,0,.82,7.93l-.43,0-.22.06a5.71,5.71,0,0,0-1.83.79,28,28,0,0,1-3.16-11.61Zm.56,9.21.22-.05.29,0q.32,1.41.72,2.73A24.87,24.87,0,0,0,411.72,98a24.79,24.79,0,0,1-4.33-5.66A5.74,5.74,0,0,1,409,91.65Zm1.8,2.38c-.25-.82-.47-1.67-.67-2.54a7.37,7.37,0,0,1,2.46.3l.24.07a9.82,9.82,0,0,1,1.49.62v7.6l-.09,0c-.28-.18-.55-.37-.83-.58A16.89,16.89,0,0,1,410.82,94Zm4.48,6.61-.1-.06V93a14.26,14.26,0,0,1,1.53,1l.24.19a20.33,20.33,0,0,1,2.5,2.43,12.25,12.25,0,0,1-.74,2c-.73,1.53-1.63,2.34-2.6,2.43C415.86,100.9,415.58,100.78,415.3,100.64Zm4-1.13a13.29,13.29,0,0,0,.8-2.14l.32.39.22.29a28.24,28.24,0,0,1,1.77,2.68,5.88,5.88,0,0,1-4.58.81A6.09,6.09,0,0,0,419.3,99.51ZM421,97.3l-.23-.31c-.14-.18-.29-.35-.44-.53a30.93,30.93,0,0,0,.75-6.73l4.82,2.78c-.11,3.57-1.19,6.26-2.93,7.78A28.11,28.11,0,0,0,421,97.3Zm.08-8.72a45,45,0,0,0-.75-7.65c.15,0,.3,0,.44,0l.23,0a6.21,6.21,0,0,0,2-.7,27.55,27.55,0,0,1,2.94,11.2Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeimg);
export default __webpack_public_path__ + "static/media/homeimg.fd8846d4576b4e6a75b6acc054f1d914.svg";
export { ForwardRef as ReactComponent };